export const UNAUTHORIZED_USER = "UNAUTHORIZED_USER";
export const INIT_LOGIN = "INIT_LOGIN";
export const INIT_CHANGEPASSWORD_FORM = "INIT_CHANGEPASSWORD_FORM";
export const OPEN_CHANGEPASSWORD_DIALOG = "OPEN_CHANGEPASSWORD_DIALOG";
export const CLOSE_CHANGEPASSWORD_DIALOG = "CLOSE_CHANGEPASSWORD_DIALOG";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_REQUEST_SUCCESS = "LOGIN_REQUEST_SUCCESS";
export const LOGIN_REQUEST_FAILED = "LOGIN_REQUEST_FAILED";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const CREATE_USER = "CREATE_USER";
export const USER_CREATED = "USER_CREATED";
export const CREATE_USER_ERROR = "CREATE_USER_ERROR";
export const RESETPASSWORD_USER = "RESETPASSWORD_USER";
export const CLEAR_RESETPASSWORD_USER = "CLEAR_RESETPASSWORD_USER";
export const USER_PASSWORDRESET = "USER_PASSWORDRESET";
export const RESETPASSWORD_USER_ERROR = "RESETPASSWORD_USER_ERROR";
export const CHANGE_USER_PASSWORD = "CHANGE_PASSWORD_USER";
export const USER_PASSWORD_CHANGED = "USER_PASSWORD_CHANGED";
export const CHANGE_USER_PASSWORD_ERROR = "CHANGE_USER_PASSWORD_ERROR";
export const CHANGE_EMPLOYEE_PASSWORD = "CHANGE_EMPLOYEE_PASSWORD";
export const EMPLOYEE_PASSWORD_CHANGED = "EMPLOYEE_PASSWORD_CHANGED";
export const CHANGE_EMPLOYEE_PASSWORD_ERROR = "CHANGE_EMPLOYEE_PASSWORD_ERROR";
export const CLEAR_EMPLOYEECHANGEPASSWORD_FORM = "CLEAR_EMPLOYEECHANGEPASSWORD_FORM";
export const FORGETPASSWORD_USER = "FORGETPASSWORD_USER";
export const CLEAR_FORGETPASSWORD_USER = "CLEAR_FORGETPASSWORD_USER";
export const USER_FORGOTPASSWORD = "USER_FORGOTPASSWORD";
export const FORGOTPASSWORD_USER_ERROR = "RESETPASSWORD_USER_ERROR";
export const GET_USER_ROLES = "GET_USER_ROLES";
export const GET_USER_ROLES_SUCCESS = "GET_USER_ROLES_SUCCESS";
export const UNLOCK_ACCOUNT = 'UNLOCK_ACCOUNT';
export const UNLOCK_PATIENT_ACCOUNT = 'UNLOCK_PATIENT_ACCOUNT';
export const PATIENT_ACCOUNT_UNLOCKED = "PATIENT_ACCOUNT_UNLOCKED";
export const VERIFY_CREDENTIAL = 'VERIFY_CREDENTIAL';
export const VERIFY_CREDENTIAL_SUCCESS = 'VERIFY_CREDENTIAL_SUCCESS';
export const VERIFY_CREDENTIAL_CLEAR = 'VERIFY_CREDENTIAL_CLEAR';

// USER ROLE
export const INITIALIZE_ROLE = "INITIALIZE_ROLE"
export const GET_ROLE = "GET_ROLE";
export const GET_ROLE_SUCCESS = "GET_ROLE_SUCCESS";
export const GET_ROLE_ERROR = "GET_ROLE_ERROR";
export const SAVE_ROLE = "SAVE_ROLE";
export const SAVE_ROLE_SUCCESS = "SAVE_ROLE_SUCCESS";
export const SAVE_ROLE_FAILED = "SAVE_ROLE_FAILED";
export const UPDATE_ROLE = "UPDATE_ROLE";
export const UPDATE_ROLE_SUCCESS = "UPDATE_ROLE_SUCCESS";
export const UPDATE_ROLE_FAILED = "UPDATE_ROLE_FAILED";
export const DELETE_ROLE = "DELETE_ROLE";
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS";
export const DELETE_ROLE_FAILED = "DELETE_ROLE_FAILED";

export const GET_POLICIES = "GET_POLICIES";
export const GET_POLICIES_SUCCESS = "GET_POLICIES_SUCCESS";
export const GET_POLICIES_FAILED = "GET_POLICIES_FAILED";

export const USERROLE_REPORT_GET = "USERROLE_REPORT_GET";
export const USERROLE_PAGE_GET = "USERROLE_PAGE_GET";
export const USERROLE_REPORT_GETBYNAME = "USERROLE_REPORT_GETBYNAME";
export const USERROLE_PAGE_GETBYNAME = "USERROLE_PAGE_GETBYNAME";
export const USERROLE_GET_REPORT_SUCCESS = "USERROLE_GET_REPORT_SUCCESS";
export const USERROLE_GET_REPORTBYNAME_SUCCESS = "USERROLE_GET_REPORTBYNAME_SUCCESS";
export const USERROLE_GET_PAGE_SUCCESS = "USERROLE_GET_PAGE_SUCCESS";
export const USERROLE_GET_PAGEBYNAME_SUCCESS = "USERROLE_GET_PAGEBYNAME_SUCCESS";
export const USERROLE_GET_REPORT_FAILED = "USERROLE_GET_REPORT_FAILED";
export const USERROLE_GET_PAGE_FAILED = "USERROLE_GET_PAGE_FAILED";
export const USERROLE_REPORT_SAVE = "USERROLE_REPORT_SAVE";
export const USERROLE_REPORT_SAVED = "USERROLE_REPORT_SAVED";
export const USERROLE_REPORT_SAVE_FAILED = "USERROLE_REPORT_SAVE_FAILED";
export const USERROLE_PAGE_SAVE = "USERROLE_PAGE_SAVE";
export const USERROLE_PAGE_SAVED = "USERROLE_PAGE_SAVED";
export const USERROLE_PAGE_SAVE_FAILED = "USERROLE_PAGE_SAVE_FAILED";

//PRODUCT
export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const PRODUCT_CREATED = 'PRODUCT_CREATED';
export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCTS_CAMPAIGN = "GET_PRODUCTS_CAMPAIGN";
export const GET_PRODUCTS_CAROUSEL = "GET_PRODUCTS_CAROUSEL";
export const GET_PRODUCT = "GET_PRODUCT";
export const GET_PRODUCT_BY_ID = "GET_PRODUCT_BY_ID";
export const PRODUCT_BY_ID_SUCCESS = "PRODUCT_BY_ID_SUCCESS";
export const PRODUCTS_GOT = "PRODUCTS_GOT";
export const PRODUCTS_GOT_CAMPAIGN = "PRODUCTS_GOT_CAMPAIGN";
export const PRODUCTS_GOT_CAROUSEL = "PRODUCTS_GOT_CAROUSEL";
export const CAROUSEL_DELETE = "CAROUSEL_DELETE";
export const PRODUCTS_CLEAR_CAROUSEL = "PRODUCTS_CLEAR_CAROUSEL";
export const PRODUCT_GOT = "PRODUCT_GOT";
export const PRODUCT_CREATE_FAILED = 'PRODUCT_CREATE_FAILED';
export const INITIALIZE_STORE_PRODUCT = 'INITIALIZE_STORE_PRODUCT';
export const INITIALIZED_STORE_PRODUCT = 'INITIALIZED_STORE_PRODUCT';
export const INITIALIZE_STORE_PRODUCT_FAILED = 'INITIALIZE_STORE_PRODUCT_FAILED';
export const BRANDS_GET = "BRANDS_GET";
export const BRANDS_GOT = "BRANDS_GOT";
export const PRODUCT_TYPES_GET = "PRODUCT_TYPES_GET";
export const PRODUCT_TYPES_GOT = "PRODUCT_TYPES_GOT";
export const LOAD_PRODUCT_PRICE_MATRIX_TABLE = 'LOAD_PRODUCT_PRICE_MATRIX_TABLE';
export const GET_PRODUCTS_BY_CATEGORY = 'GET_PRODUCTS_BY_CATEGORY';
export const PRODUCTS_BY_CATEGORY_GOT = 'PRODUCTS_BY_CATEGORY_GOT';
export const GET_PRODUCTS_CATEGORIES = 'GET_PRODUCTS_CATEGORIES';
export const PRODUCTS_CATEGORIES_GOT = 'PRODUCTS_CATEGORIES_GOT';
export const GET_PRODUCTS_CATEGORIES_DROPDOWN = 'GET_PRODUCTS_CATEGORIES_DROPDOWN';
export const PRODUCTS_CATEGORIES_DROPDOWN_GOT = 'PRODUCTS_CATEGORIES_DROPDOWN_GOT';
export const INITIALIZE_STORE_PRODUCT_CHANGE_TYPE = 'INITIALIZE_STORE_PRODUCT_CHANGE_TYPE';
export const REST_PRODUCT_CATEGORIES = 'REST_PRODUCT_CATEGORIES';
export const GET_PRODUCT_ORDERS = 'GET_PRODUCT_ORDERS';
export const GOT_PRODUCT_ORDERS = 'GOT_PRODUCT_ORDERS';
export const GET_CAMPAIGN_LIST = 'GET_CAMPAIGN_LIST';
export const GOT_CAMPAIGN_LIST = 'GOT_CAMPAIGN_LIST';
export const GET_PURCHASE_ORDER_LIST = 'GET_PURCHASE_ORDER_LIST';
export const GOT_PURCHASE_ORDER_LIST = 'GOT_PURCHASE_ORDER_LIST';
export const UNRECEIVE_PO_PRODUCT = 'UNRECEIVE_PO_PRODUCT';
export const UNRECEIVE_ALL = 'UNRECEIVE_ALL';
export const UNRECEIVE_ALL_SUCCESS = 'UNRECEIVE_ALL_SUCCESS';
export const UNRECEIVE_ALL_FAIL = 'UNRECEIVE_ALL_FAIL';
export const DELETE_PO = 'DELETE_PO';
export const DELETE_PO_SUCCESS = 'DELETE_PO_SUCCESS';
export const GOT_PRODUCT_DETAIL = 'GOT_PRODUCT_DETAIL';
export const RESET_PRODUCT_LIST = 'RESET_PRODUCT_LIST';
export const GET_PRODUCT_BY_BARCODE = 'GET_PRODUCT_BY_BARCODE';
export const GET_PRODUCT_BY_BARCODE_SUCCESS = 'GET_PRODUCT_BY_BARCODE_SUCCESS';
export const GET_PRODUCT_BY_BARCODE_FAIL = 'GET_PRODUCT_BY_BARCODE_FAIL';
export const CHECK_COMBO_PRODUCT_QUANTITY = 'CHECK_COMBO_PRODUCT_QUANTITY';
export const CHECK_COMBO_PRODUCT_QUANTITY_SUCCESS = 'CHECK_COMBO_PRODUCT_QUANTITY_SUCCESS';
export const CHECK_COMBO_PRODUCT_QUANTITY_FAILURE = 'CHECK_COMBO_PRODUCT_QUANTITY_FAILURE';
export const CLEAN_PRODUCT_DETAIL = 'CLEAN_PRODUCT_DETAIL';
export const CLEAN_ORDER_DETAIL = 'CLEAN_ORDER_DETAIL';
export const EDIT_PRODUCT_UPC = 'EDIT_PRODUCT_UPC';
export const UPC_EDITED = 'UPC_EDITED';
export const UPDATE_UNIT_PRICE_DATABASE = 'UPDATE_UNIT_PRICE_DATABASE';
export const UPC_EDIT_BARCODE_EXIST = 'UPC_EDIT_BARCODE_EXIST';
export const GET_PRODUCT_LOCATIONS = 'GET_PRODUCT_LOCATIONS';
export const GET_PRODUCT_LOCATIONS_SUCCESS = 'GET_PRODUCT_LOCATIONS_SUCCESS';
export const GET_PRODUCT_LOCATIONS_FAIL = 'GET_PRODUCT_LOCATIONS_FAIL';
export const GET_INVENTORY_FLAG = 'GET_INVENTORY_FLAG';
export const GET_INVENTORY_FLAG_SUCCESS = 'GET_INVENTORY_FLAG_SUCCESS';
export const GET_INVENTORY_FLAG_FAIL = 'GET_INVENTORY_FLAG_FAIL';
export const CLEAR_INVENTORY_FLAG = 'CLEAR_INVENTORY_FLAG';
export const CLEAR_INVENTORY_FLAG_SUCCESS = 'CLEAR_INVENTORY_FLAG_SUCCESS';
export const CLEAR_INVENTORY_FLAG_FAIL = 'CLEAR_INVENTORY_FLAG_FAIL';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';
export const INVENTORY_ADJUST_ROUND_PRICES = 'INVENTORY_ADJUST_ROUND_PRICES';
export const INVENTORY_ADJUST_ROUND_PRICES_SUCCESS = 'INVENTORY_ADJUST_ROUND_PRICES_SUCCESS';
export const BULK_UPDATE_MEMBER_PRICE = 'BULK_UPDATE_MEMBER_PRICE';
export const BULK_UPDATE_MEMBER_PRICE_SUCCESS = 'BULK_UPDATE_MEMBER_PRICE_SUCCESS';
export const GET_BULK_MEMBER_PRICE_HISTORY = 'GET_BULK_MEMBER_PRICE_HISTORY';
export const GET_BULK_MEMBER_PRICE_CATEGORY_HISTORY = 'GET_BULK_MEMBER_PRICE_CATEGORYS_HISTORY';
export const GET_BULK_MEMBER_PRICE_HISTORY_SUCCESS = 'GET_BULK_MEMBER_PRICE_HISTORY_SUCCESS';
export const GET_BULK_MEMBER_PRICE_CATEGORY_HISTORY_SUCCESS = 'GET_BULK_MEMBER_PRICE_CATEGORYS_HISTORY_SUCCESS';
export const GET_BULK_MEMBER_PRICE_HISTORY_FAIL = 'GET_BULK_MEMBER_PRICE_HISTORY_FAIL';
export const GET_BULK_MEMBER_PRICE_CATEGORY_HISTORY_FAIL = 'GET_BULK_MEMBER_PRICE_CATEGORYS_HISTORY_FAIL';
export const GET_PRODUCT_CATEGORY_BULK_UPDATE_PRICE_HISTORY = 'GET_PRODUCT_CATEGORY_BULK_UPDATE_PRICE_HISTORY';
export const GET_PRODUCT_CATEGORY_BULK_UPDATE_PRICE_HISTORY_SUCCESS = 'GET_PRODUCT_CATEGORY_BULK_UPDATE_PRICE_HISTORY_SUCCESS';
export const GET_PRODUCT_CATEGORY_BULK_UPDATE_PRICE_HISTORY_FAIL = 'GET_PRODUCT_CATEGORY_BULK_UPDATE_PRICE_HISTORY_FAIL';
export const CATEGORY_UPDATE_MEMBER_PRICE = 'CATEGORY_UPDATE_MEMBER_PRICE';
export const CATEGORY_UPDATE_MEMBER_PRICE_SUCCESS = 'CATEGORY_UPDATE_MEMBER_PRICE_SUCCESS';
export const CATEGORY_UPDATE_MEMBER_PRICE_SUCCESS_RESET = 'CATEGORY_UPDATE_MEMBER_PRICE_SUCCESS_RESET';
export const INITIALIZE_POPAGE_PRODUCT_LIST = 'INITIALIZE_POPAGE_PRODUCT_LIST';
export const UPLOAD_PRODUCT = "UPLOAD_PRODUCT";
export const UPLOAD_PRODUCT_SUCCESS = "UPLOAD_PRODUCT_SUCCESS";
export const UPLOAD_PRODUCT_FAIL = "UPLOAD_PRODUCT_FAIL";
export const SET_BULK_TRANSFER_BRANCH_FROM = "SET_BULK_TRANSFER_BRANCH_FROM";
export const SET_BULK_TRANSFER_BRANCH_TO = "SET_BULK_TRANSFER_BRANCH_TO";
export const GET_PRODUCT_CATALOG_LIST = "GET_PRODUCT_CATALOG_LIST";

//VENDOR
export const SAVE_VENDOR = 'SAVE_VENDOR';
export const VENDOR_SAVED = 'VENDOR_SAVED';
export const VENDOR_SAVED_FAILED = 'VENDOR_SAVED_FAILED';
export const GET_VENDOR = "GET_VENDOR";
export const GET_VENDORS = "GET_VENDORS";
export const GET_VENDORS_BY_COUNTRY_STATE = "GET_VENDORS_BY_COUNTRY_STATE";
export const VENDORS_GOT = "VENDORS_GOT";
export const VENDOR_GOT = "VENDOR_GOT";
export const INITIALIZE_STORE_VENDOR = 'INITIALIZE_STORE_VENDOR';
export const VENDOR_LIST_LOAD = 'VENDOR_LIST_LOAD';
export const VENDOR_LIST_LOADED = 'VENDOR_LIST_LOADED';
export const VENDOR_PRODUCT_IMPORT = 'VENDOR_PRODUCT_IMPORT';
export const VENDOR_PRODUCT_IMPORT_SUCCESS = 'VENDOR_PRODUCT_IMPORT_SUCCESS';
export const VENDOR_PRODUCT_IMPORT_FAIL = 'VENDOR_PRODUCT_IMPORT_FAIL';
export const GET_ACCESSORY_VENDORS = 'GET_ACCESSORY_VENDORS';
export const GET_ACCESSORY_VENDORS_SUCCESS = 'GET_ACCESSORY_VENDORS_SUCCESS';

//CATEGORY
export const CREATE_CATEGORY = 'CREATE_CATEGORY';
export const CATEGORY_CREATED = 'CATEGORY_CREATED';
export const CATEGORY_CREATE_FAILED = 'CATEGORY_CREATE_FAILED';

//FORM
export const FORM_INPUT = 'FORM_INPUT';
export const FORM_ERROR = 'FORM_ERROR';
export const CLEAR_FORM_ERRORS = 'CLEAR_FORM_ERRORS'
export const CLEAR_FORM_INPUT = 'CLEAR_FORM_INPUT';
//FORM MEDICAL INFORMATION
export const INITIALIZE_STORE_MEDICAL_INFORMATION = 'INITIALIZE_STORE_MEDICAL_INFORMATION';
export const FORM_MEDICAL_INFORMATION_ADD = 'FORM_MEDICAL_INFORMATION_ADD';
export const FORM_MEDICAL_INFORMATION_REMOVE = 'FORM_MEDICAL_INFORMATION_REMOVE';
export const FORM_MEDICAL_INFORMATION_INPUT = 'FORM_MEDICAL_INFORMATION_INPUT';

// export const GET_CATEGORIES = 'GET_CATEGORIES';
// export const RECEIVED_CATEGORIES = 'RECEIVED_CATEGORIES';

export const VALIDATE = 'VALIDATE';

//PATIENT
export const INITIALIZE_STORE_PATIENT = 'INITIALIZE_STORE_PATIENT';
export const SAVE_PATIENT = 'SAVE_PATIENT';
export const PATIENT_LIST_LOAD = 'PATIENT_LIST_LOAD';
export const PATIENT_LIST_LOADED = 'PATIENT_LIST_LOADED';
export const PATIENT_SAVED = 'PATIENT_SAVED';
export const PATIENT_SAVE_FAILED = 'PATIENT_SAVE_FAILED';
export const PATIENT_FORM_LOAD = 'PATIENT_FORM_LOAD';
export const PATIENT_FORM_LOADED = 'PATIENT_FORM_LOADED';
export const GOT_PATIENT_DETAIL = 'GOT_PATIENT_DETAIL';
export const GET_PATIENT_DETAIL = 'GET_PATIENT_DETAIL';
export const RESET_PATIENT_LISTS = 'RESET_PATIENT_LISTS';
export const MERMBER_MERGE_SUCCESS = 'MERMBER_MERGE_SUCCESS';
export const SPRING_BIG_NOTIFICATIONS = 'SPRING_BIG_NOTIFICATIONS';
export const EDIT_ELITE_MEMBERSHIP = "EDIT_ELITE_MEMBERSHIP";
export const EDIT_ELITE_MEMBERSHIP_SUCCESS = "EDIT_ELITE_MEMBERSHIP_SUCCESS";
export const EDIT_ELITE_MEMBERSHIP_FAILED = "EDIT_ELITE_MEMBERSHIP_FAILED";


//DOCTOR
export const INITIALIZE_STORE_DOCTOR = 'INITIALIZE_STORE_DOCTOR';
export const DOCTOR_LIST_LOAD = 'DOCTOR_LIST_LOAD';
export const DOCTOR_LIST_LOADED = 'DOCTOR_LIST_LOADED';
export const DOCTOR_SAVE = 'DOCTOR_SAVE';
export const DOCTOR_CREATED = 'DOCTOR_CREATED';
export const DOCTOR_EDITED = 'DOCTOR_EDITED';
export const DOCTOR_SAVE_FAILED = 'DOCTOR_SAVE_FAILED';
export const DOCTOR_EDIT_LOAD = 'DOCTOR_EDIT_LOAD';
export const DOCTOR_EDIT_LOADED = 'DOCTOR_EDIT_LOADED';
export const DOCTOR_INACTIVATE = 'DOCTOR_INACTIVATE';
export const DOCTOR_ACTIVATE = 'DOCTOR_ACTIVATE';

//EMPLOYEE
export const EMPLOYEE_LIST_LOAD = 'EMPLOYEE_LIST_LOAD';
export const EMPLOYEE_IMPORT_TEMPLATE_SUCCESS = 'EMPLOYEE_IMPORT_TEMPLATE_SUCCESS'
export const EMPLOYEE_IMPORT_TEMPLATE = 'EMPLOYEE_IMPORT_TEMPLATE';
export const EMPLOYEE_LIST_LOADED = 'EMPLOYEE_LIST_LOADED';
export const INITIALIZE_STORE_EMPLOYEE = 'INITIALIZE_STORE_EMPLOYEE';
export const EMPLOYEE_GET = 'EMPLOYEE_GET';
export const EMPLOYEE_GOT = 'EMPLOYEE_GOT';
export const EMPLOYEE_GET_DETAILS = 'EMPLOYEE_GET_DETAILS';
export const EMPLOYEE_GOT_DETAILS = 'EMPLOYEE_GOT_DETAILS';
export const EMPLOYEE_SAVE = 'EMPLOYEE_SAVE';
export const EMPLOYEE_SAVED = 'EMPLOYEE_SAVED';
export const EMPLOYEE_SAVE_FAILED = 'EMPLOYEE_SAVE_FAILED';
export const GET_ALL_EMPLOYEES = 'GET_ALL_EMPLOYEES';
export const ALL_EMPLOYEES_GOT = 'ALL_EMPLOYEES_GOT';
export const RESET_EMPLOYEE_LISTS = 'RESET_EMPLOYEE_LISTS';
export const GET_AUTHENTICATED_EMPLOYEE = 'GET_AUTHENTICATED_EMPLOYEE';
export const AUTHENTICATED_EMPLOYEE_GOT = 'AUTHENTICATED_EMPLOYEE_GOT';
export const GET_ACTIVE_EMPLOYEE_BY_BRANCH = 'GET_ACTIVE_EMPLOYEE_BY_BRANCH';
export const GET_ACTIVE_EMPLOYEE_BY_BRANCH_SUCCESS = 'GET_ACTIVE_EMPLOYEE_BY_BRANCH_SUCCESS';
export const GET_ACTIVE_EMPLOYEE_BY_BRANCH_FAIL = 'GET_ACTIVE_EMPLOYEE_BY_BRANCH_FAIL';
export const GET_EMPLOYEE_BY_FILTER = 'GET_EMPLOYEE_BY_FILTER';
export const GET_EMPLOYEE_BY_FILTER_SUCCESS = 'GET_EMPLOYEE_BY_FILTER_SUCCESS';
export const SEND_MESSAGE = "SEND_MESSAGE";
export const SEND_TEST_MESSAGE = 'SEND_TEST_MESSAGE';
export const UPDATE_TWILIO_INFO = 'UPDATE_TWILIO_INFO';
export const UPDATE_TWILIO_INFO_SUCCESS = 'UPDATE_TWILIO_INFO_SUCCESS';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const RESET_MESSAGE_SUCCESS = 'RESET_MESSAGE_SUCCESS';
export const UPLOAD_IMAGE = 'UPLOAD_IMAGE';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';

//COMMON
export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
export const SHOW_DOWNLOADING = 'SHOW_DOWNLOADING'
export const SNACKBAR_SHOW_MESSAGE = 'SNACKBAR_SHOW_MESSAGE';
export const SNACKBAR_HIDE_MESSAGE = 'SNACKBAR_HIDE_MESSAGE';
export const DIALOG_ALERT_OPEN = 'DIALOG_ALERT_OPEN';
export const DIALOG_ALERT_CLOSE = 'DIALOG_ALERT_CLOSE';
export const SET_BRANCH_CONTEXT = 'SET_BRANCH_CONTEXT';
export const GET_USER_BRANCHES = 'GET_USER_BRANCHES';
export const GET_USER_BRANCHES_SUCCESS = 'GET_USER_BRANCHES_SUCCESS';
export const GET_USER_BRANCHES_ERROR = 'GET_USER_BRANCHES_ERROR';
export const CHANGE_USER_BRANCH = 'CHANGE_USER_BRANCH';
export const CHANGE_STORE = 'CHANGE_STORE';
export const SELECT_STORE = 'SELECT_STORE';
export const GET_APPLICATION_SETTING = 'GET_APPLICATION_SETTING';
export const APPLICATION_SETTING_GOT = 'APPLICATION_SETTING_GOT';
export const GET_APPLICATION_SETTING_INTEGRATION = 'GET_APPLICATION_SETTING_INTEGRATION';
export const APPLICATION_SETTING_INTEGRATION_GOT = 'APPLICATION_SETTING_INTEGRATION_GOT';
export const GET_APPLICATION_SETTING_ERROR = 'GET_APPLICATION_SETTING_ERROR';
export const SAVE_APPLICATION_SETTING = 'SAVE_APPLICATION_SETTING';
export const APPLICATION_SETTING_SAVED = 'APPLICATION_SETTING_SAVED';
export const SAVE_APPLICATION_SETTING_ERROR = 'SAVE_APPLICATION_SETTING_ERROR';

//PURCHASE ORDER
export const INITIALIZE_STORE_PURCHASEORDER = 'INITIALIZE_STORE_PURCHASEORDER';
export const INITIALIZE_STORE_PO_PRODUCT = 'INITIALIZE_STORE_PO_PRODUCT';
export const SAVE_PURCHASE_ORDER = 'SAVE_PURCHASE_ORDER';
export const PURCHASE_ORDER_CREATED = 'PURCHASE_ORDER_CREATED';
export const PURCHASE_ORDER_EDITED = 'PURCHASE_ORDER_EDITED';
export const PURCHASE_ORDER_SAVE_ERROR = 'PURCHASE_ORDER_SAVE_ERROR';
export const PURCHASE_ORDER_LOAD = 'PURCHASE_ORDER_LOAD';
export const PURCHASE_ORDER_PRODUCT = 'PURCHASE_ORDER_PRODUCT';
export const PURCHASE_PRODUCT_LOADED = 'PURCHASE_PRODUCT_LOADED';
export const ADD_PRODUCT_PO = 'ADD_PRODUCT_PO';
export const LOAD_PO_PRODUCT = 'LOAD_PO_PRODUCT';
export const PURCHASE_FORM_LOADED = 'PURCHASE_FORM_LOADED';
export const REMOVE_PO_PRODUCT = 'REMOVE_PO_PRODUCT';
export const UPDATE_PURCHASE_ORDER = 'UPDATE_PURCHASE_ORDER'
export const UPDATE_PO_UNRECEIVE = 'UPDATE_PO_UNRECEIVE'
export const PO_LIST_LOAD = 'PO_LIST_LOAD';
export const PO_LIST_LOADED = 'PO_LIST_LOADED';
export const PO_FOR_BULK_TRANSFER = 'PO_FOR_BULK_TRANSFER';
export const PURCHASE_ORDER_CANCEL = 'PURCHASE_ORDER_CANCEL';
export const PURCHASE_ORDER_OPEN = 'PURCHASE_ORDER_OPEN';
export const PURCHASE_ORDER_ONORDER = 'PURCHASE_ORDER_ONORDER';
export const PO_STATUS_SAVE_FAILED = 'PO_STATUS_SAVE_FAILED';
export const PURCHASE_ORDER_IMPORT = 'PURCHASE_ORDER_IMPORT';
export const PURCHASE_ORDER_IMPORT_SUCCESS = 'PURCHASE_ORDER_IMPORT_SUCCESS';
export const PURCHASE_ORDER_IMPORT_FAIL = 'PURCHASE_ORDER_IMPORT_FAIL';
export const POS_ORDER_IMPORT_TEMPLATE = 'POS_ORDER_IMPORT_TEMPLATE';
export const POS_ORDER_IMPORT_TEMPLATE_SUCCESS = 'POS_ORDER_IMPORT_TEMPLATE_SUCCESS';
export const POS_ORDER_IMPORT_TEMPLATE_FAIL = 'POS_ORDER_IMPORT_TEMPLATE_FAIL';
export const POS_ORDER_IMPORT_TEMPLATE_CLEAR = 'POS_ORDER_IMPORT_TEMPLATE_CLEAR';
export const PURCHASE_ORDER_IMPORT_TEMPLATE = 'PURCHASE_ORDER_IMPORT_TEMPLATE';
export const PURCHASE_ORDER_IMPORT_TEMPLATE_SUCCESS = 'PURCHASE_ORDER_IMPORT_TEMPLATE_SUCCESS';
export const PURCHASE_ORDER_IMPORT_TEMPLATE_FAIL = 'PURCHASE_ORDER_IMPORT_TEMPLATE_FAIL';
export const PURCHASE_ORDER_CANNABIS_TEMPLATE = 'PURCHASE_ORDER_CANNABIS_TEMPLATE';
export const PURCHASE_ORDER_CANNABIS_TEMPLATE_SUCCESS = 'PURCHASE_ORDER_CANNABIS_TEMPLATE_SUCCESS';
export const PURCHASE_ORDER_CANNABIS_TEMPLATE_FAIL = 'PURCHASE_ORDER_CANNABIS_TEMPLATE_FAIL';
export const PURCHASE_ORDER_VAPE_TEMPLATE = 'PURCHASE_ORDER_VAPE_TEMPLATE';
export const PURCHASE_ORDER_VAPE_TEMPLATE_SUCCESS = 'PURCHASE_ORDER_VAPE_TEMPLATE_SUCCESS';
export const PURCHASE_ORDER_VAPE_TEMPLATE_FAIL = 'PURCHASE_ORDER_VAPE_TEMPLATE_FAIL';
export const PO_RECEIVE_BARCODE_EXIST = 'PO_RECEIVE_BARCODE_EXIST';

//INVENTORY ADJUST
export const GET_INVENTORY_ADJUST = 'GET_INVENTORY_ADJUST';
export const GET_INVENTORY_ADJUST_SUCCESS = 'GET_INVENTORY_ADJUST_SUCCESS';
export const GET_INVENTORY_ADJUST_FAIL = 'GET_INVENTORY_ADJUST_FAIL';
export const CLEAR_INVENTORY_ADJUST = 'CLEAR_INVENTORY_ADJUST';

export const SAVE_INVENTORY_ADJUST = 'SAVE_INVENTORY_ADJUST';
export const SAVE_INVENTORY_ADJUST_SUCCESS = 'SAVE_INVENTORY_ADJUST_SUCCESS';
export const SAVE_INVENTORY_ADJUST_FAIL = 'SAVE_INVENTORY_ADJUST_FAIL';

//TRANSFER PRODUCT
export const WAREHOUSES_GET = 'WAREHOUSES_GET';
export const WAREHOUSES_GET_SUCCESS = 'WAREHOUSES_GET_SUCCESS';
export const WAREHOUSES_GET_ERROR = 'WAREHOUSES_GET_ERROR';
export const PRODUCTS_IN_TRANSIT_LOAD = 'PRODUCTS_IN_TRANSIT_LOAD';
export const PRODUCTS_IN_TRANSIT_LOADED = 'PRODUCTS_IN_TRANSIT_LOADED';
export const RECEIVE_PRODUCT_PO = 'RECEIVE_PRODUCT_PO';
export const PRODUCT_PO_RECEIVED = 'PRODUCT_PO_RECEIVED';
export const PRODUCT_PO_RECEIVE_FAILED = 'PRODUCT_PO_RECEIVE_FAILED';
export const INITIALIZE_STORE_RECEIVE_PURCHASEORDER = 'INITIALIZE_STORE_RECEIVE_PURCHASEORDER';
export const PRODUCTWAREHOUSE_LIST_LOAD = 'PRODUCTWAREHOUSE_LIST_LOAD';
export const PRODUCTWAREHOUSE_GROUPED_LIST_LOAD = 'PRODUCTWAREHOUSE_GROUPED_LIST_LOAD';
export const SEND_BULK_TRANSFER = 'SEND_BULK_TRANSFER';
export const PRODUCTWAREHOUSE_AUTOCOMPLETE_LIST_LOAD = 'PRODUCTWAREHOUSE_AUTOCOMPLETE_LIST_LOAD';
export const GET_PRODUCT_BARCODE_INVENTORY_AUDIT = 'GET_PRODUCT_BARCODE_INVENTORY_AUDIT'
export const BULK_TRANSFER_EXCEL_SEARCH = 'BULK_TRANSFER_EXCEL_SEARCH';
export const BULK_TRANSFER_LIST_LOAD = 'BULK_TRANSFER_LIST_LOAD';
export const BULK_TRANSFER_By_ID = 'BULK_TRANSFER_By_ID';
export const BULK_TRANSFER_PPRODUCT_QUANTITY = 'BULK_TRANSFER_PPRODUCT_QUANTITY';
export const BULK_TRANSFER_CONFIRM = 'BULK_TRANSFER_CONFIRM';
export const GET_PENDING_BULK_TRANSFER_PRODUCTS = 'GET_PENDING_BULK_TRANSFER_PRODUCTS';
export const GET_PENDING_BULK_TRANSFER_PRODUCTS_SUCCESS = 'GET_PENDING_BULK_TRANSFER_PRODUCTS_SUCCESS';
export const PRODUCTWAREHOUSE_LIST_LOADED = 'PRODUCTWAREHOUSE_LIST_LOADED';
export const PRODUCTWAREHOUSE_GROUPED_LIST_LOADED = 'PRODUCTWAREHOUSE_GROUPED_LIST_LOADED';
export const BULK_TRANSFER_SUCCESS = 'BULK_TRANSFER_SUCCESS';
export const BULK_TRANSFER_FAIL = 'BULK_TRANSFER_FAIL';
export const PRODUCTWAREHOUSE_AUTOCOMPLETE_LIST_LOADED = 'PRODUCTWAREHOUSE_AUTOCOMPLETE_LIST_LOADED';
export const GET_PRODUCT_BARCODE_INVENTORY_AUDIT_SUCCESS = 'GET_PRODUCT_BARCODE_INVENTORY_AUDIT_SUCCESS';
export const BULK_TRANSFER_EXCEL_SEARCH_LIST_LOADED = 'BULK_TRANSFER_EXCEL_SEARCH_LIST_LOADED';
export const BULK_TRANSFER_LIST_LOADED = 'BULK_TRANSFER_LIST_LOADED';
export const BULK_TRANSFER_LOADED = 'BULK_TRANSFER_LOADED';
export const PRODUCT_QUANTITY_LOADED = 'PRODUCT_QUANTITY_LOADED';
export const BULK_TRANSFER_CONFIRM_SUCCESS = 'BULK_TRANSFER_CONFIRM_SUCCESS';
export const TRANSFER_PRODUCT_WAREHOUSE = 'TRANSFER_PRODUCT_WAREHOUSE';
export const PRODUCT_WAREHOUSE_TRANSFERED = 'PRODUCT_WAREHOUSE_TRANSFERED';
export const TRANSFER_PRODUCT_WAREHOUSE_FAILED = 'TRANSFER_PRODUCT_WAREHOUSE_FAILED';
export const CLEAN_COMPONENTS_TABLE = 'CLEAN_COMPONENTS_TABLE';
export const MERGE_PRODUCT_WAREHOUSE = 'MERGE_PRODUCT_WAREHOUSE';
export const PRODUCT_WAREHOUSE_MERGED = 'PRODUCT_WAREHOUSE_MERGED';
export const PRODUCT_WAREHOUSE_REFRESH = 'PRODUCT_WAREHOUSE_REFRESH';
export const CLEAR_WAREHOUSE_DATA = 'CLEAR_WAREHOUSE_DATA';
export const SET_SELECTED_PRODUCT_ADJUSTMENT = 'SET_SELECTED_PRODUCT_ADJUSTMENT';
export const SEND_TRANSFER_PRODUCT = 'SEND_TRANSFER_PRODUCT';
export const SEND_BULKTOUNIT_PRODUCT = 'SEND_BULKTOUNIT_PRODUCT';
export const CLEAR_SELECTED_PRODUCT_ADJUSTMENT = 'CLEAR_SELECTED_PRODUCT_ADJUSTMENT';
export const ADJUST_PRODUCT_WAREHOUSE = 'ADJUST_PRODUCT_WAREHOUSE';
export const ADJUST_PRODUCT_WAREHOUSE_SUCCESS = 'ADJUST_PRODUCT_WAREHOUSE_SUCCESS';
export const ADJUST_PRODUCT_QTY = 'ADJUST_PRODUCT_QTY';
export const ADJUST_PRODUCT_QTY_SUCCESS = 'ADJUST_PRODUCT_QTY_SUCCESS';
export const ADJUST_PRODUCT_WAREHOUSE_ERROR = 'ADJUST_PRODUCT_WAREHOUSE_ERROR';
export const CONVERT_BULK_TO_UNIT = 'CONVERT_BULK_TO_UNIT';
export const CONVERT_BULK_TO_UNIT_SUCCESS = 'CONVERT_BULK_TO_UNIT_SUCCESS';
export const CONVERT_BULK_TO_UNIT_ERROR = 'CONVERT_BULK_TO_UNIT_ERROR';
export const WAREHOUSES_CLEAR = 'WAREHOUSES_CLEAR';
export const CLEAR_ONHOLD_QTY = 'CLEAR_ONHOLD_QTY';
export const CLEAR_ONHOLD_QTY_SUCCESS = 'CLEAR_ONHOLD_QTY_SUCCESS';
export const CLEAR_ONHOLD_QTY_FAIL = 'CLEAR_ONHOLD_QTY_FAIL';
export const TRANSFER_PRODUCTS_TO_WAREHOUSE = 'TRANSFER_PRODUCTS_TO_WAREHOUSE';
export const TRANSFER_PRODUCTS_TO_WAREHOUSE_SUCCESS = 'TRANSFER_PRODUCTS_TO_WAREHOUSE_SUCCESS';
export const WORDPRESS_SYNC_ALL_PRODUCTS = 'WORDPRESS_SYNC_ALL_PRODUCTS';
export const WORDPRESS_SYNC_ALL_PRODUCTS_SUCCESS = 'WORDPRESS_SYNC_ALL_PRODUCTS_SUCCESS';
export const WORDPRESS_LOOKUP_UNMAPPED_PRODUCTS = 'WORDPRESS_LOOKUP_UNMAPPED_PRODUCTS';
export const WORDPRESS_LOOKUP_UNMAPPED_PRODUCTS_SUCCESS = 'WORDPRESS_LOOKUP_UNMAPPED_PRODUCTS_SUCCESS';
export const CLEAN_WAREHOUSE_ERRORS = 'CLEAN_WAREHOUSE_ERRORS';
export const GET_PRODUCT_INVENTORY_BY_BRANCH = 'GET_PRODUCT_INVENTORY_BY_BRANCH';
export const GET_PRODUCT_INVENTORY_BY_BRANCH_SUCCESS = 'GET_PRODUCT_INVENTORY_BY_BRANCH_SUCCESS';
export const GET_PRODUCT_INVENTORY_BY_BRANCH_FAIL = 'GET_PRODUCT_INVENTORY_BY_BRANCH_FAIL';
export const CLEAN_PRODUCT_INVENTORY_BY_BRANCH = 'CLEAN_PRODUCT_INVENTORY_BY_BRANCH';
export const BULK_TRANSFER_SCAN_PRODUCT_SUCCESS = 'BULK_TRANSFER_SCAN_PRODUCT_SUCCESS';

// AUDIT
export const GET_AUDIT = 'GET_AUDIT';
export const GET_AUDIT_SUCCESS = 'GET_AUDIT_SUCCESS';
export const GET_AUDITS = 'GET_AUDITS';
export const GET_AUDITS_SUCCESS = 'GET_AUDITS_SUCCESS';
export const AUDIT_SAVE = 'AUDIT_SAVE';
export const AUDIT_SAVE_SUCCESS = 'AUDIT_SAVE_SUCCESS';
export const AUDIT_DELETE = 'AUDIT_DELETE';
export const AUDIT_DELETE_SUCCESS = "AUDIT_DELETE_SUCCESS";
export const FILTER_AUDIT_LIST_STATUS = 'FILTER_AUDIT_LIST_STATUS';
export const FILTER_AUDIT_LIST_STATUS_SUCCESS = "FILTER_AUDIT_LIST_STATUS_SUCCESS";
export const AUDIT_UPDATE_SUCCESS = 'AUDIT_UPDATE_SUCCESS';
export const AUDIT_UPDATE_PART_SUCCESS = 'AUDIT_UPDATE_PART_SUCCESS';
export const AUDIT_SAVE_FAIL = 'AUDIT_SAVE_FAIL';
export const AUDIT_WAREHOUSES = 'AUDIT_WAREHOUSES';
export const AUDIT_WAREHOUSES_SUCCESS = 'AUDIT_WAREHOUSES_SUCCESS';
export const AUDIT_COMPLETE = 'AUDIT_COMPLETE';
export const AUDIT_VERIFY = 'AUDIT_VERIFY';
export const AUDIT_RECOUNT = 'AUDIT_RECOUNT';
export const AUDIT_PRODUCTS = 'AUDIT_PRODUCTS';
export const PRODUCTS_AUDIT_GOT = 'PRODUCTS_AUDIT_GOT';
export const AUDIT_CATEGORY = 'AUDIT_CATEGORY';
export const CATEGORY_AUDIT_GOT = 'CATEGORY_AUDIT_GOT';
export const AUDIT_UNCOUNTED = 'AUDIT_UNCOUNTED';
export const UNCOUNTED_AUDIT_GOT = 'UNCOUNTED_AUDIT_GOT';
export const AUDIT_CATEGORIES = 'AUDIT_CATEGORIES';
export const CATEGORIES_AUDIT_GOT = 'CATEGORIES_AUDIT_GOT';
export const GET_BRANDS = 'GET_BRANDS';
export const AUDIT_BRAND = 'AUDIT_BRAND';
export const BRAND_AUDIT_GOT = 'BRAND_AUDIT_GOT';
export const BRANDS_GOT_LIST = 'BRANDS_GOT_LIST';
export const AUDIT_PRODUCT_REMOVE = 'AUDIT_PRODUCT_REMOVE';
export const AUDIT_PRODUCT_ADD = 'AUDIT_PRODUCT_ADD';
export const AUDIT_UPDATE_NAME = 'AUDIT_UPDATE_NAME';
export const AUDIT_PRODUCT_UPDATE_QUANTITY = 'AUDIT_PRODUCT_UPDATE_QUANTITY';
export const AUDIT_PRODUCT_UPDATE_EXPECTED_QTY = 'AUDIT_PRODUCT_UPDATE_EXPECTED_QTY';
export const AUDIT_PRODUCT_UPDATE_DIFF_QTY = 'AUDIT_PRODUCT_UPDATE_DIFF_QTY';
export const AUDIT_PRODUCT_UPDATE_NOTES = 'AUDIT_PRODUCT_UPDATE_NOTES';
export const AUDIT_PRODUCT_QTY_WITH_LOCK_SUCCESS = 'AUDIT_PRODUCT_QTY_WITH_LOCK_SUCCESS';
export const AUDIT_PRODUCT_UPDATE_EXPECTED_QTY_SUCCESS = 'AUDIT_PRODUCT_UPDATE_EXPECTED_QTY_SUCCESS';
export const AUDIT_PRODUCT_UPDATE_DIFF_QTY_SUCCESS = 'AUDIT_PRODUCT_UPDATE_DIFF_QTY_SUCCESS';

// WEIGHT SETTINGS
export const INITIALIZE_STORE_WEIGHT_SETTING = 'INITIALIZE_STORE_WEIGHT_SETTING';
export const WEIGHT_SETTING_SAVE = 'WEIGHT_SETTING_SAVE';
export const WEIGHT_SETTING_SAVED = 'WEIGHT_SETTING_SAVED';
export const WEIGHT_SETTING_SAVE_ERROR = 'WEIGHT_SETTING_SAVE_ERROR';
export const WEIGHT_SETTING_GET = 'WEIGHT_SETTING_GET';
export const WEIGHT_SETTING_GOT = 'WEIGHT_SETTING_GOT';
export const WEIGHT_SETTING_GET_ALL = 'WEIGHT_SETTING_GET_ALL';
export const WEIGHT_SETTING_GOT_ALL = 'WEIGHT_SETTING_GOT_ALL';

// PRICE MATRIX
export const INITIALIZE_STORE_PRICE_MATRIX = 'INITIALIZE_STORE_PRICE_MATRIX';
export const PRICE_MATRIX_GET_ALL = 'PRICE_MATRIX_GET_ALL';
export const PRICE_MATRIX_GOT_ALL = 'PRICE_MATRIX_GOT_ALL';
export const PRICE_MATRIX_GET = 'PRICE_MATRIX_GET';
export const PRICE_MATRIX_GOT = 'PRICE_MATRIX_GOT';
export const GET_PRICE_MATRIX_BY_ID = 'GET_PRICE_MATRIX_BY_ID';
export const GET_PRICE_MATRIX_SUCCESS = 'GET_PRICE_MATRIX_SUCCESS';
export const PRICE_MATRIX_SAVE = 'PRICE_MATRIX_SAVE';
export const PRICE_MATRIX_SAVED = 'PRICE_MATRIX_SAVED';
export const PRICE_MATRIX_SAVE_ERROR = 'PRICE_MATRIX_SAVE_ERROR';
export const PRICE_MATRIX_PRODUCTS_APPLY = 'PRICE_MATRIX_PRODUCTS_APPLY';
export const PRICE_MATRIX_PRODUCTS_APPLY_ERROR = 'PRICE_MATRIX_PRODUCTS_APPLY_ERROR';
export const PRICE_MATRIX_PRODUCTS_APPLIED = 'PRICE_MATRIX_PRODUCTS_APPLIED';
export const APPLY_MEMBER_DISCOUNT_PRICE_MATRIX = 'APPLY_MEMBER_DISCOUNT_PRICE_MATRIX';

// POS
export const GET_POS = 'GET_POS';
export const POS_GOT = 'POS_GOT';
export const GET_POS_ERROR = 'GET_POS_ERROR';
export const INITIALIZE_STORE_POS = 'INITIALIZE_STORE_POS';
export const INITIALIZE_STORE_POS_PATIENT = 'INITIALIZE_STORE_POS_PATIENT';
export const GET_SELLABLE_PRODUCTS = 'GET_SELLABLE_PRODUCTS';
export const SELLABLE_PRODUCTS_GOT = 'SELLABLE_PRODUCTS_GOT';
export const GET_SELLABLE_PRODUCTS_ERROR = 'GET_SELLABLE_PRODUCTS_ERROR';
export const GET_SELLABLE_PRODUCT_BY_ID = 'GET_SELLABLE_PRODUCT_BY_ID';
export const GET_SELLABLE_PRODUCT_BY_ID_ERROR = 'GET_SELLABLE_PRODUCT_BY_ID_ERROR';
export const SET_CACHED_PRODUCTS = 'SET_CACHED_PRODUCTS';
export const SEARCH_CACHED_PRODUCTS = 'SEARCH_CACHED_PRODUCTS';
export const SELABLE_BY_ID_GOT = 'SELABLE_BY_ID_GOT';
export const CLEAR_POS_FILTER = 'CLEAR_POS_FILTER';
export const GET_POS_PATIENTS = 'GET_POS_PATIENTS';
export const POS_PATIENTS_GOT = 'POS_PATIENTS_GOT';
export const GET_POS_PATIENTS_ERROR = 'GET_POS_PATIENTS_ERROR';
export const LINK_PATIENT_POS_ORDER = 'LINK_PATIENT_POS_ORDER';
export const GET_PRODUCT_POS = 'GET_PRODUCT_POS';
export const PRODUCT_POS_GOT = 'PRODUCT_POS_GOT';
export const GET_PRODUCT_POS_ERROR = 'GET_PRODUCT_POS_ERROR';
export const INITIALIZE_POS_ADD_PRODUCT = 'INITIALIZE_POS_ADD_PRODUCT';
export const SAVE_POS_ORDER = 'SAVE_POS_ORDER';
export const POS_ORDER_SAVED = 'POS_ORDER_SAVED';
export const POS_ORDER_SAVED_PRINT_RECEIPT = 'POS_ORDER_SAVED_PRINT_RECEIPT';
export const SAVE_POS_ORDER_ERROR = 'SAVE_POS_ORDER_ERROR';
export const CHECK_ORDER_UPDATE_TIME = 'CHECK_ORDER_UPDATE_TIME';
export const CHECK_ORDER_UPDATE_TIME_OK = 'CHECK_ORDER_UPDATE_TIME_OK';
export const CHECK_ORDER_UPDATE_TIME_REFUND_OK = 'CHECK_ORDER_UPDATE_TIME_REFUND_OK';
export const CHECK_ORDER_UPDATE_TIME_FAIL = 'CHECK_ORDER_UPDATE_TIME_FAIL';
export const ADD_PRODUCT_TO_POS_ORDER = 'ADD_PRODUCT_TO_POS_ORDER';
export const ADD_COMBO_PRODUCT_TO_POS_ORDER = 'ADD_COMBO_PRODUCT_TO_POS_ORDER';
export const SAVE_POS_ORDER_OFFLINE = 'SAVE_POS_ORDER_OFFLINE';
export const CLEAR_OFFLINE_ORDER_ERROR = 'CLEAR_OFFLINE_ORDER_ERROR'
export const UPDATE_PACKAGE_REFERENCE = 'UPDATE_PACKAGE_REFERENCE';
export const VOID_POS_ORDER_OFFLINE_PRODUCT = 'VOID_POS_ORDER_OFFLINE_PRODUCT';
export const VOID_POS_ORDER_PRODUCT = 'VOID_POS_ORDER_PRODUCT';
export const POS_ORDER_PRODUCT_VOIDED = 'POS_ORDER_PRODUCT_VOIDED';
export const VOID_POS_ORDER_PRODUCT_ERROR = 'VOID_POS_ORDER_PRODUCT_ERROR';
export const ADD_PAYMENT_POS_ORDER = 'ADD_PAYMENT_POS_ORDER';
export const CLEAR_TAX_POS_ORDER = 'CLEAR_TAX_POS_ORDER';
export const CLEAR_TAX_POS_ORDER_SUCCESS = 'CLEAR_TAX_POS_ORDER_SUCCESS';
export const CLEAR_TAX_POS_ORDER_FAIL = 'CLEAR_TAX_POS_ORDER_FAIL';
export const ADD_SHIPPING_COST = 'ADD_SHIPPING_COST';
export const ADD_SHIPPING_COST_SUCCESS = 'ADD_SHIPPING_COST_SUCCESS';
export const ADD_SHIPPING_COST_FAIL = 'ADD_SHIPPING_COST_FAIL';
export const ADD_TIP_AMOUNT = 'ADD_TIP_AMOUNT';
export const ADD_TIP_AMOUNT_SUCCESS = 'ADD_TIP_AMOUNT_SUCCESS';
export const ADD_TIP_AMOUNT_FAIL = 'ADD_TIP_AMOUNT_FAIL';
export const PAYMENT_POS_ORDER_ADDED = 'PAYMENT_POS_ORDER_ADDED';
export const ADD_PAYMENT_POS_ORDER_ERROR = 'ADD_PAYMENT_POS_ORDER_ERROR';
export const GET_POS_ORDER = 'GET_POS_ORDER';
export const GET_POS_ORDER_ERROR = 'GET_POS_ORDER_ERROR';
export const CANCEL_POS_ORDER = 'CANCEL_POS_ORDER';
export const POS_ORDER_CANCELLED = 'POS_ORDER_CANCELLED';
export const POS_ORDER_CANCELLED_ALL = 'POS_ORDER_CANCELLED_ALL';
export const CANCEL_POS_ORDER_ERROR = 'CANCEL_POS_ORDER_ERROR';
export const CLEAR_POS_ERROR = 'CLEAR_POS_ERROR';
export const CLEAR_POS_CANCELLATION = 'CLEAR_POS_CANCELLATION';
export const GET_ALL_ORDER_BY = 'GET_POS_ORDER';
export const CLEAR_ADMIN_ORDER_CANCELLATION = 'CLEAR_ADMIN_ORDER_CANCELLATION';
export const GET_WEIGHT_POS = "GET_WEIGHT_POS";
export const GOT_WEIGHT_POS = "GOT_WEIGHT_POS";
export const GET_WEIGHT_POS_ERROR = "GET_WEIGHT_POS_ERROR";
export const SET_ORDER_DISCOUNT = 'SET_ORDER_DISCOUNT';
export const SET_ORDER_VISIT_DISCOUNT = 'SET_ORDER_VISIT_DISCOUNT';
export const SET_ORDER_DISCOUNT_SUCCESS = 'SET_ORDER_DISCOUNT_SUCCESS';
export const SET_ORDER_DISCOUNT_ERROR = 'SET_ORDER_DISCOUNT_ERROR';
export const SET_ORDER_PRODUCT_DISCOUNT = 'SET_ORDER_PRODUCT_DISCOUNT';
export const SET_ORDER_PRODUCT_DISCOUNT_SUCCESS = 'SET_ORDER_PRODUCT_DISCOUNT_SUCCESS';
export const SET_ORDER_PRODUCT_DISCOUNT_ERROR = 'SET_ORDER_PRODUCT_DISCOUNT_ERROR';
export const REMOVE_ORDER_DISCOUNT = 'REMOVE_ORDER_DISCOUNT';
export const REMOVE_ORDER_DISCOUNT_SUCCESS = 'REMOVE_ORDER_DISCOUNT_SUCCESS';
export const REMOVE_ORDER_DISCOUNT_ERROR = 'REMOVE_ORDER_DISCOUNT_ERROR';
export const REMOVE_ORDER_PRODUCT_DISCOUNT = 'REMOVE_ORDER_PRODUCT_DISCOUNT';
export const REMOVE_ORDER_PRODUCT_DISCOUNT_SUCCESS = 'REMOVE_ORDER_PRODUCT_DISCOUNT_SUCCESS';
export const REMOVE_ORDER_PRODUCT_DISCOUNT_ERROR = 'REMOVE_ORDER_PRODUCT_DISCOUNT_ERROR';
export const INITIALIZE_STORE_POS_REMOVE_DISCOUNT = 'INITIALIZE_STORE_POS_REMOVE_DISCOUNT';
export const INITIALIZE_STORE_POS_DISCOUNT = 'INITIALIZE_STORE_POS_DISCOUNT';
export const FINALIZE_POS_ORDER = 'FINALIZE_POS_ORDER';
export const FINALIZE_POS_ORDER_SUCCESS = 'FINALIZE_POS_ORDER_SUCCESS';
export const FINALIZE_POS_ORDER_ERROR = 'FINALIZE_POS_ORDER_ERROR';
export const CHECK_PRICE_ESTIMATION = 'CHECK_PRICE_ESTIMATION';
export const CHECK_PRICE_ESTIMATION_SUCCESS = 'CHECK_PRICE_ESTIMATION_SUCCESS';
export const CHECK_PRICE_ESTIMATION_ERROR = 'CHECK_PRICE_ESTIMATION_ERROR';
export const CLEAN_REFUND_FORM = 'CLEAN_REFUND_FORM';
export const ADD_REFUND_ORDER = 'ADD_REFUND_ORDER';
export const ADDED_REFUND_ORDER = 'ADDED_REFUND_ORDER';
export const ADD_REFUND_ORDER_ERROR = 'ADD_REFUND_ORDER_ERROR';
export const SEND_ORDER_EMAIL_RECEIPT = 'SEND_ORDER_EMAIL_RECEIPT';
export const ORDER_EMAIL_RECEIPT_SENT = 'ORDER_EMAIL_RECEIPT_SENT';
export const SEND_ORDER_EMAIL_RECEIPT_ERROR = 'SEND_ORDER_EMAIL_RECEIPT_ERROR';
export const SEND_ORDER_SMS_RECEIPT = 'SEND_ORDER_SMS_RECEIPT';
export const ORDER_SMS_RECEIPT_SENT = 'ORDER_SMS_RECEIPT_SENT';
export const SEND_ORDER_SMS_RECEIPT_ERROR = 'SEND_ORDER_SMS_RECEIPT_ERROR';
export const SET_PRODUCT_FILTER = 'SET_PRODUCT_FILTER';
export const GET_DEVICE_BY_IP = 'GET_DEVICE_BY_IP';
export const GET_DEVICE_BY_IP_SUCCESS = 'GET_DEVICE_BY_IP_SUCCESS';
export const GET_DEVICE_BY_IP_FAIL = 'GET_DEVICE_BY_IP_FAIL';
export const SEND_ORDER_TO_FULFILLMENT = 'SEND_ORDER_TO_FULFILLMENT';
export const SEND_ORDER_TO_FULFILLMENT_SUCCESS = 'SEND_ORDER_TO_FULFILLMENT_SUCCESS';
export const SEND_ORDER_TO_FULFILLMENT_FAIL = 'SEND_ORDER_TO_FULFILLMENT_FAIL';
export const MANAGER_APPROVAL = 'MANAGER_APPROVAL';
export const MANAGER_APPROVAL_SUCCESS = 'MANAGER_APPROVAL_SUCCESS';
export const MANAGER_APPROVAL_FAILED = 'MANAGER_APPROVAL_FAILED';
export const SET_PRODUCT_LIST_EMPTY = 'SET_PRODUCT_LIST_EMPTY';
export const ASSIGN_MEMBER = 'ASSIGN_MEMBER';
export const GET_PRODUCT_SUGGESTION = 'GET_PRODUCT_SUGGESTION';
export const GET_PRODUCT_SUGGESTION_SUCCESS = 'GET_PRODUCT_SUGGESTION_SUCCESS';
export const UPDATE_PRICE_MATCH_PRODUCT = 'UPDATE_PRICE_MATCH_PRODUCT';
export const CLEAR_PRICE_MATCH_ROWS = 'CLEAR_PRICE_MATCH_ROWS';
export const REMOVE_PRICE_MATCH_PRODUCT = 'REMOVE_PRICE_MATCH_PRODUCT';


// DEVICE
export const INITIALIZE_STORE_DEVICE = 'INITIALIZE_STORE_DEVICE';
export const DEVICE_SAVE = 'DEVICE_SAVE';
export const DEVICE_SAVED = 'DEVICE_SAVED';
export const DEVICE_SAVE_ERROR = 'DEVICE_SAVE_ERROR';
export const DEVICE_GET = 'DEVICE_GET';
export const DEVICE_GOT = 'DEVICE_GOT';
export const DEVICE_GET_ALL = 'DEVICE_GET_ALL';
export const STORE_GET_ALL = 'STORE_GET_ALL';
export const DEVICE_GOT_ALL = 'DEVICE_GOT_ALL';
export const GETIPADDRESS = 'GETIPADDRESS';
export const UPDATEIPADDRESS = 'UPDATEIPADDRESS';
export const UPDATE_DEVICE_IP = 'UPDATE_DEVICE_IP';
export const UPDATE_DEVICE_IP_ERROR = 'UPDATE_DEVICE_IP_ERROR';
export const DEVICE_IP_UPDATED = 'DEVICE_IP_UPDATED';

//STORE LIST
export const STORES_GOT_ALL = 'STORES_GOT_ALL';

// DEVICE TYPE
export const DEVICETYPE_GET_ALL = 'DEVICETYPE_GET_ALL';
export const DEVICETYPE_GOT_ALL = 'DEVICETYPE_GOT_ALL';

// DEVICE ROLE
export const INITIALIZE_STORE_DEVICE_ROLE = 'INITIALIZE_STORE_DEVICE_ROLE';
export const DEVICEROLE_GET_ALL = 'DEVICEROLE_GET_ALL';
export const DEVICEROLE_GOT_ALL = 'DEVICEROLE_GOT_ALL';
export const SAVE_DEVICEROLE = 'SAVE_DEVICEROLE';
export const DEVICEROLE_SAVED = 'DEVICEROLE_SAVED';
export const SAVE_DEVICEROLE_ERROR = 'SAVE_DEVICEROLE_ERROR';

// DEVICE WORKSTATION
export const INITIALIZE_STORE_DEVICE_WORKSTATION = 'INITIALIZE_STORE_DEVICE_WORKSTATION';
export const DEVICEWORKSTATION_GET_ALL = 'DEVICEWORKSTATION_GET_ALL';
export const DEVICEWORKSTATION_GOT_ALL = 'DEVICEWORKSTATION_GOT_ALL';
export const DEVICEWORKSTATION_SAVE = 'DEVICEWORKSTATION_SAVE';
export const DEVICEWORKSTATION_SAVED = 'DEVICEWORKSTATION_SAVED';
export const DEVICEWORKSTATION_SAVE_ERROR = 'DEVICEWORKSTATION_SAVE_ERROR';

// PAYMENT
export const INITIALIZE_STORE_PAYMENT = 'INITIALIZE_STORE_PAYMENT';
export const PAYMENT_SAVE = 'PAYMENT_SAVE';
export const PAYMENT_SAVED = 'PAYMENT_SAVED';
export const PAYMENT_SAVE_ERROR = 'PAYMENT_SAVE_ERROR';
export const PAYMENT_GET = 'PAYMENT_GET';
export const PAYMENT_GOT = 'PAYMENT_GOT';
export const PAYMENT_GET_ALL = 'PAYMENT_GET_ALL';
export const PAYMENT_GOT_ALL = 'PAYMENT_GOT_ALL';

// TAXRATE
export const INITIALIZE_STORE_TAXRATE = 'INITIALIZE_STORE_TAXRATE';
export const TAXRATE_SAVE = 'TAXRATE_SAVE';
export const TAXRATE_SAVED = 'TAXRATE_SAVED';
export const TAXRATE_SAVE_ERROR = 'TAXRATE_SAVE_ERROR';
export const TAXRATE_GET = 'TAXRATE_GET';
export const TAXRATE_GOT = 'TAXRATE_GOT';
export const TAXRATE_GET_ALL = 'TAXRATE_GET_ALL';
export const TAXRATE_GOT_ALL = 'TAXRATE_GOT_ALL';

// SAFE MANAGEMENT
export const SAFEMANAGEMENT_INSERT = 'SAFEMANAGEMENT_INSERT';
export const SAFEMANAGEMENT_SAVED = 'SAFEMANAGEMENT_SAVED';
export const SAFEMANAGEMENT_SAVED_ERROR = 'SAFEMANAGEMENT_SAVED_ERROR';
export const SAFEMANAGEMENT_GET_ALL = 'SAFEMANAGEMENT_GET_ALL';
export const SAFEMANAGEMENT_GOT_ALL = 'SAFEMANAGEMENT_GOT_ALL';

// BANK DEPOSITS
export const BANKDEPOSITS_GET = 'BANKDEPOSITS_GET';
export const BANKDEPOSITS_GOT = 'BANKDEPOSITS_GOT';
export const BANKDEPOSITS_GET_ALL = 'BANKDEPOSITS_GET_ALL';
export const BANKDEPOSITS_GOT_ALL = 'BANKDEPOSITS_GOT_ALL';
export const BANKDEPOSITS_INSERT = 'BANKDEPOSITS_INSERT';
export const BANKDEPOSITS_UPDATE = 'BANKDEPOSITS_UPDATE';
export const BANKDEPOSITS_SAVED = 'BANKDEPOSITS_SAVED';
export const BANKDEPOSITS_SAVED_ERROR = 'BANKDEPOSITS_SAVED_ERROR';
export const BANKDEPOSITS_INITIALIZE_STORE = 'BANKDEPOSITS_INITIALIZE_STORE';

// CASHFLOW
export const CASHFLOW_GET = 'CASHFLOW_GET';
export const CASHFLOW_GOT = 'CASHFLOW_GOT';
export const CASHFLOW_SAVE_CASHIN = 'CASHFLOW_SAVE_CASHIN';
export const CASHFLOW_SAVED_CASHIN = 'CASHFLOW_SAVED_CASHIN';
export const CASHFLOW_SAVE_CASHOUT = 'CASHFLOW_SAVE_CASHOUT';
export const CASHFLOW_SAVED_CASHOUT = 'CASHFLOW_SAVED_CASHOUT';
export const CASHFLOW_SAVE_CASHOUTMANUAL = 'CASHFLOW_SAVE_CASHOUTMANUAL';
export const CASHFLOW_SAVED_CASHOUTMANUAL = 'CASHFLOW_SAVED_CASHOUTMANUAL';
export const CASHFLOW_SAVE_CASHINOUT_ERROR = 'CASHFLOW_SAVE_CASHINOUT_ERROR';
export const CASHFLOW_SAVED_CASHIN_ERROR = 'CASHFLOW_SAVED_CASHIN_ERROR';
export const CLEAN_CASHFLOW_SAVED_CASHIN_ERROR = 'CLEAN_CASHFLOW_SAVED_CASHIN_ERROR';
export const CASHFLOW_GET_ALL = 'CASHFLOW_GET_ALL';
export const CASHFLOW_GOT_ALL = 'CASHFLOW_GOT_ALL';
export const CASHFLOW_CLOSEREGISTER = 'CASHFLOW_CLOSEREGISTER';
export const CASHFLOW_CLOSEDREGISTER = 'CASHFLOW_CLOSEDREGISTER';
export const CASHFLOW_SAVE_CASHDROP = 'CASHFLOW_SAVE_CASHDROP';
export const CASHFLOW_SAVED_CASHDROP = 'CASHFLOW_SAVED_CASHDROP';
export const CASHFLOW_SAVE_CASHDROP_ERROR = 'CASHFLOW_SAVE_CASHDROP_ERROR';
export const CASHFLOW_ORDERS_GET = 'CASHFLOW_ORDERS_GET';
export const CASHFLOW_ORDERS_GET_ERROR = 'CASHFLOW_ORDERS_GET_ERROR';
export const CASHFLOW_ORDERS_GOT = 'CASHFLOW_ORDERS_GOT';
export const CASHFLOW_VERIFY_CASHOUT = 'CASHFLOW_VERIFY_CASHOUT';
export const CASHFLOW_CASHOUT_VERIFIED = 'CASHFLOW_CASHOUT_VERIFIED';
export const CASHFLOW_NOT_VERIFY_CASHOUT = 'CASHFLOW_NOT_VERIFY_CASHOUT';
export const CASHFLOW_CASHOUT_NOT_VERIFIED = 'CASHFLOW_CASHOUT_NOT_VERIFIED';
export const CASHFLOW_CASHOUT_ERROR = 'CASHFLOW_CASHOUT_ERROR';
export const CASHFLOW_CLOSE_REGISTERS = 'CASHFLOW_CLOSE_REGISTERS';
export const CASHFLOW_CLOSE_REGISTERS_ERROR = 'CASHFLOW_CLOSE_REGISTERS_ERROR';
export const CASHFLOW_REGISTERS_CLOSED = 'CASHFLOW_REGISTERS_CLOSED';
export const CASHFLOW_CLOSEINPROGRESS_REGISTERS = 'CASHFLOW_CLOSEINPROGRESS_REGISTERS';
export const CASHFLOW_REGISTERS_CLOSED_FROM_CASHIN = 'CASHFLOW_REGISTERS_CLOSED_FROM_CASHIN';
export const CLEAR_CASHFLOW = 'CLEAR_CASHFLOW';
export const CASHFLOW_NOTES = 'CASHFLOW_NOTES';
export const CASHFLOW_REGISTER_COUNT_SAVE = 'CASHFLOW_REGISTER_COUNT_SAVE';
export const CASHFLOW_REGISTER_COUNT_GET = 'CASHFLOW_REGISTER_COUNT_GET';
export const CASHFLOW_REGISTER_COUNT_GOT = 'CASHFLOW_REGISTER_COUNT_GOT';
export const CASHFLOW_REGISTER_COUNT_CLEAR = 'CASHFLOW_REGISTER_COUNT_CLEAR';

// ORDER
export const OPEN_ORDERS_GET = 'OPEN_ORDERS_GET';
export const OPEN_ORDERS_GOT = 'OPEN_ORDERS_GOT';
export const OPEN_ORDERS_GET_ERROR = 'OPEN_ORDERS_GET_ERROR';
export const RECENT_ORDERS_GET = 'RECENT_ORDERS_GET';
export const RECENT_ORDERS_GOT = 'RECENT_ORDERS_GOT';
export const RECENT_ORDERS_GET_ERROR = 'RECENT_ORDERS_GET_ERROR';
export const OLD_OPEN_ORDERS_GET = 'OLD_OPEN_ORDERS_GET';
export const OLD_OPEN_ORDERS_GOT = 'OLD_OPEN_ORDERS_GOT';
export const OLD_OPEN_ORDERS_GET_ERROR = 'OLD_OPEN_ORDERS_GET_ERROR';
export const CANCEL_OPEN_ORDERS = 'CANCEL_OPEN_ORDERS';
export const CANCEL_OPEN_ORDERS_SUCCESS = 'CANCEL_OPEN_ORDERS_SUCCESS';
export const CANCEL_OPEN_ORDERS_FAIL = 'CANCEL_OPEN_ORDERS_FAIL';
export const CANCEL_OPEN_ONLINE_ORDERS = 'CANCEL_OPEN_ONLINE_ORDERS';
export const CANCEL_OPEN_ONLINE_ORDERS_SUCCESS = 'CANCEL_OPEN_ONLINE_ORDERS_SUCCESS';
export const CANCEL_OPEN_ONLINE_ORDERS_FAIL = 'CANCEL_OPEN_ONLINE_ORDERS_FAIL';
export const ID_ORDER_HISTORY_DIALOG = 'ID_ORDER_HISTORY_DIALOG';
export const CANCEL_ALL_OPEN_ORDERS = 'CANCEL_ALL_OPEN_ORDERS';


// BRANCHGET_PRODUCT_CATEGORIES
export const BRANCHES_GET = 'BRANCHES_GET';
export const BRANCHES_GOT = 'BRANCHES_GOT';

// PRODUCT CATEGORY
export const GET_PRODUCT_CATEGORIES = 'GET_PRODUCT_CATEGORIES';
export const GET_PRODUCT_CATEGORIES_SUCCESS = 'GET_PRODUCT_CATEGORIES_SUCCESS';
export const GET_PRODUCT_CATEGORIES_ERROR = 'GET_PRODUCT_CATEGORIES_ERROR';
export const GET_PRODUCT_CATEGORIES_BYBRANCHS = 'GET_PRODUCT_CATEGORIES_BYBRANCHS';
export const GET_PRODUCT_CATEGORIES_BYBRANCHS_SUCCESS = 'GET_PRODUCT_CATEGORIES_BYBRANCHS_SUCCESS';
export const GET_PRODUCT_CATEGORIES_BYBRANCHS_ERROR = 'GET_PRODUCT_CATEGORIES_ERROR';

export const GET_CATEGORY_TREE = 'GET_CATEGORY_TREE';
export const GET_CATEGORY_TREE_SUCCESS = 'GET_CATEGORY_TREE_SUCCESS';
export const GET_CATEGORY_TREE_FAIL = 'GET_CATEGORY_TREE_FAIL';

export const CLEAR_PRODUCT_CATEGORY_FORM = 'CLEAR_PRODUCT_CATEGORY_FORM';
export const GET_PRODUCT_CATEGORY = 'GET_PRODUCT_CATEGORY';
export const GET_PRODUCT_CATEGORY_SUCCESS = 'GET_PRODUCT_CATEGORY_SUCCESS';
export const GET_PRODUCT_CATEGORY_ERROR = 'GET_PRODUCT_CATEGORY_ERROR';
export const SAVE_PRODUCT_CATEGORY = 'SAVE_PRODUCT_CATEGORY';
export const SAVE_PRODUCT_CATEGORY_SUCCESS = 'SAVE_PRODUCT_CATEGORY_SUCCESS';
export const SAVE_PRODUCT_CATEGORY_ERROR = 'SAVE_PRODUCT_CATEGORY_ERROR';
export const GET_CLASSES_OF_CANNABIS = 'GET_CLASSES_OF_CANNABIS';
export const GET_CLASSES_OF_CANNABIS_SUCCESS = 'GET_CLASSES_OF_CANNABIS_SUCCESS';
export const GET_CLASSES_OF_CANNABIS_FAIL = 'GET_CLASSES_OF_CANNABIS_FAIL';
export const SET_PRICE_BY_CATEGORY = 'SET_PRICE_BY_CATEGORY';
export const SET_PRICE_BY_CATEGORY_SUCCESS = 'SET_PRICE_BY_CATEGORY_SUCCESS';
export const SET_PRICE_BY_CATEGORY_FAIL = 'SET_PRICE_BY_CATEGORY_FAIL';
export const SAVE_PRODUCT_CATEGORY_TAX_PROVINCE = 'SAVE_PRODUCT_CATEGORY_TAX_PROVINCE';
export const SAVE_PRODUCT_CATEGORY_TAX_PROVINCE_SUCCESS = 'SAVE_PRODUCT_CATEGORY_TAX_PROVINCE_SUCCESS';
export const SAVE_PRODUCT_CATEGORY_TAX_PROVINCE_FAIL = 'SAVE_PRODUCT_CATEGORY_TAX_PROVINCE_FAIL';

// CAMPAIGN PAGE
export const CAMPAIGN_GET_ALL = 'CAMPAIGN_GET_ALL';
export const CAMPAIGN_GET_ALL_ONLINE = 'CAMPAIGN_GET_ALL_ONLINE';
export const CAMPAIGN_GET = 'CAMPAIGN_GET';
export const CAMPAIGN_GOT_ALL = 'CAMPAIGN_GOT_ALL';
export const CAMPAIGN_GOT_ALL_ERROR = 'CAMPAIGN_GOT_ALL_ERROR';
export const CAMPAIGN_GOT = 'CAMPAIGN_GOT';
export const CAMPAIGN_GOT_ERROR = 'CAMPAIGN_GOT_ERROR';
export const CAMPAIGN_SAVE = 'CAMPAIGN_SAVE';
export const CAMPAIGN_SAVED = 'CAMPAIGN_SAVED';
export const CAMPAIGN_SAVED_ERROR = 'CAMPAIGN_SAVED_ERROR';
export const CLEAR_CAMPAIGN_FORM = 'CLEAR_CAMPAIGN_FORM';
export const CLEAR_CAMPAIGN_ITEMS_DIALOG = 'CLEAR_CAMPAIGN_ITEMS_DIALOG';
export const CAMPAIGN_DELETE = 'CAMPAIGN_DELETE';
export const CAMPAIGN_DELETE_SUCCESS = 'CAMPAIGN_DELETE_SUCCESS';
export const CAMPAIGN_DELETE_FAIL = 'CAMPAIGN_DELETE_FAIL';

//COMBO

export const COMBO_GET_ALL = 'COMBO_GET_ALL';
export const COMBO_GET_ALL_SUCCESS = 'COMBO_GET_ALL_SUCCESS';
export const COMBO_GET_ALL_FAIL = 'COMBO_GET_ALL_FAIL';
export const COMBO_GET = 'COMBO_GET';
export const COMBO_GET_SUCCESS = 'COMBO_GET_SUCCESS';
export const COMBO_GET_FAIL = 'COMBO_GET_FAIL';
export const COMBO_SAVE = 'COMBO_SAVE';
export const COMBO_SAVE_SUCCESS = 'COMBO_SAVE_SUCCESS';
export const COMBO_SAVE_FAIL = 'COMBO_SAVE_FAIL';
export const CLEAR_COMBO_FORM = 'CLEAR_COMBO_FORM';
export const CLEAR_COMBO_ITEMS_DIALOG = 'CLEAR_COMBO_ITEMS_DIALOG';
export const COMBO_DELETE = 'COMBO_DELETE';

//CUSTOM DISCOUNT
export const DISCOUNT_GET_ALL = 'DISCOUNT_GET_ALL';
export const DISCOUNT_GET_ALL_SUCCESS = 'DISCOUNT_GET_ALL_SUCCESS';
export const DISCOUNT_GET_ALL_FAIL = 'DISCOUNT_GET_ALL_FAIL';
export const DISCOUNT_GET = 'DISCOUNT_GET';
export const DISCOUNT_GET_SUCCESS = 'DISCOUNT_GET_SUCCESS';
export const DISCOUNT_GET_FAIL = 'DISCOUNT_GET_FAIL';
export const DISCOUNT_SAVE = 'DISCOUNT_SAVE';
export const DISCOUNT_SAVE_SUCCESS = 'DISCOUNT_SAVE_SUCCESS';
export const DISCOUNT_SAVE_FAIL = 'DISCOUNT_SAVE_FAIL';
export const CLEAR_DISCOUNT_FORM = 'CLEAR_DISCOUNT_FORM';
export const DISCOUNT_DELETE = 'DISCOUNT_DELETE';

// CLOCK IN
export const SAVE_CLOCKIN_CLOCKOUT = 'SAVE_CLOCKIN_CLOCKOUT';
export const CLOCKIN_CLOCKOUT_SAVED = 'CLOCKIN_CLOCKOUT_SAVED';
export const SAVE_CLOCKIN_CLOCKOUT_ERROR = 'SAVE_CLOCKIN_CLOCKOUT_ERROR';

// SHIFT
export const GET_SHIFTS_FILTER = 'GET_SHIFTS_FILTER';
export const SHIFTS_GOT_FILTER = 'SHIFTS_GOT_FILTER';
export const SHIFTS_GOT = 'SHIFTS_GOT';
export const GET_SHIFTS_ERROR = 'GET_SHIFTS_ERROR';
export const GET_EMPLOYEE_SHIFT = 'GET_EMPLOYEE_SHIFT';
export const GET_EMPLOYEE_SHIFT_BY_STATUS = 'GET_EMPLOYEE_SHIFT_BY_STATUS';
export const EMPLOYEE_SHIFT_GOT = 'EMPLOYEE_SHIFT_GOT';
export const GET_EMPLOYEE_SHIFT_ERROR = 'GET_EMPLOYEE_SHIFT_ERROR';
export const CLEAN_EMPLOYEE_SHIFT_FORM = 'CLEAN_EMPLOYEE_SHIFT_FORM';
export const SAVE_EMPLOYEE_SHIFT = 'SAVE_EMPLOYEE_SHIFT';
export const EMPLOYEE_SHIFT_SAVED = 'EMPLOYEE_SHIFT_SAVED';
export const SAVE_EMPLOYEE_SHIFT_ERROR = 'SAVE_EMPLOYEE_SHIFT_ERROR';
export const SAVE_SHIFT = 'SAVE_SHIFT';
export const SAVE_SHIFT_ERROR = 'SAVE_SHIFT_ERROR';
export const SHIFT_SAVED = 'SHIFT_SAVED';

// ORDER
export const GET_ORDER_DETAIL = 'GET_ORDER_DETAIL';
export const ORDER_DETAIL_GOT = 'ORDER_DETAIL_GOT';
export const GET_ORDER_DETAIL_ERROR = 'GET_ORDER_DETAIL_ERROR';
export const GET_PATIENT_ORDERS = 'GET_PATIENT_ORDERS';
export const GET_ORDER_PATIENT_REWARD = 'GET_ORDER_PATIENT_REWARD';
export const GET_ORDER_PATIENT_REWARD_SUCCESS = 'GET_ORDER_PATIENT_REWARD_SUCCESS';
export const ORDERS_PATIENT_GOT = 'ORDERS_PATIENT_GOT';
export const GET_ORDERS_PATIENT_ERROR = 'GET_ORDERS_PATIENT_ERROR';
export const GET_CASHFLOW_ORDERS_DETAIL = 'GET_CASHFLOW_ORDERS_DETAIL';
export const GET_CASHFLOW_ORDERS_DETAIL_SUCCESS = 'GET_CASHFLOW_ORDERS_DETAIL_SUCCESS';
export const GET_CASHFLOW_ORDERS_DETAIL_FAIL = 'GET_CASHFLOW_ORDERS_DETAIL_FAIL';

//SPRING BIG
export const GET_SPRINGBIG_OFFERS = 'GET_SPRINGBIG_OFFERS';
export const GET_SPRINGBIG_OFFERS_SUCCESS = 'GET_SPRINGBIG_OFFERS_SUCCESS';
export const GET_SPRINGBIG_REWARDS = 'GET_SPRINGBIG_REWARDS';
export const GET_SPRINGBIG_REWARDS_SUCCESS = 'GET_SPRINGBIG_REWARDS_SUCCESS';
export const GET_SPRINGBIG_MEMBERPOINTS = 'GET_SPRINGBIG_MEMBERPOINTS';
export const GET_SPRINGBIG_MEMBERPOINTS_SUCCESS = 'GET_SPRINGBIG_MEMBERPOINTS_SUCCESS';
export const POST_SPRINGBIG_OFFER_DISCOUNT = 'POST_SPRINGBIG_OFFER_DISCOUNT';
export const POST_SPRINGBIG_OFFER_DISCOUNT_SUCCESS = 'POST_SPRINGBIG_OFFER_DISCOUNT_SUCCESS';
export const POST_SPRINGBIG_REWARD_DISCOUNT = 'POST_SPRINGBIG_REWARD_DISCOUNT';
export const POST_SPRINGBIG_REWARD_DISCOUNT_SUCCESS = 'POST_SPRINGBIG_REWARD_DISCOUNT_SUCCESS';

//ALPINE IQ
export const ALPINEIQ_VERIFY_WALLET = 'ALPINEIQ_VERIFY_WALLET';
export const ALPINEIQ_VERIFY_WALLET_SUCCESS = 'ALPINEIQ_VERIFY_WALLET_SUCCESS';
export const ALPINEIQ_VIEW_WALLET = 'ALPINEIQ_VIEW_WALLET';
export const ALPINEIQ_VIEW_WALLET_SUCCESS = 'ALPINEIQ_VIEW_WALLET_SUCCESS';
export const CLEAR_ALPINEIQ = 'CLEAR_ALPINEIQ';
export const ALPINEIQ_REGISTER = 'ALPINEIQ_REGISTER';
export const ALPINEIQ_REGISTER_SUCCESS = 'ALPINEIQ_REGISTER_SUCCESS';
export const POST_ALPINEIQ_DISCOUNT = 'POST_ALPINEIQ_DISCOUNT';
export const ALPINEIQ_CHECKIN = 'ALPINEIQ_CHECKIN';
export const ADD_DUTCHIE_OR_LEAFLY_AS_ONLINE_ORDER = 'ADD_DUTCHIE_OR_LEAFLY_AS_ONLINE_ORDER';

//REPORTS ACTIONS
export const GET_CATEGORY_SALES = 'GET_CATEGORY_SALES';
export const GOT_CATEGORY_SALES = 'GOT_CATEGORY_SALES';
export const GET_CATEGORY_SALES_ERROR = 'GET_CATEGORY_SALES_ERROR';

export const GET_BUDGET_PLANNER_REPORT = 'GET_BUDGET_PLANNER_REPORT';
export const GOT_BUDGET_PLANNER_REPORT = 'GOT_BUDGET_PLANNER_REPORT';
export const GET_BUDGET_PLANNER_REPORT_ERROR = 'GET_BUDGET_PLANNER_REPORT_ERROR';


export const GET_PRODUCT_VELOCITY = 'GET_PRODUCT_VELOCITY';
export const GOT_PRODUCT_VELOCITY = 'GOT_PRODUCT_VELOCITY';
export const GET_PRODUCT_VELOCITY_ERROR = 'GET_PRODUCT_VELOCITY_ERROR';

export const GET_EMPLOYEE_ACTVITY = 'GET_EMPLOYEE_ACTVITY';
export const GOT_EMPLOYEE_ACTIVITY = 'GOT_EMPLOYEE_ACTIVITY';
export const GET_EMPLOYEE_ACTVITY_ERROR = 'GET_EMPLOYEE_ACTVITY';

export const GET_ANNUAL_SALES = 'GET_ANNUAL_SALES';
export const GOT_ANNUAL_SALES = 'GOT_ANNUAL_SALES';
export const GET_ANNUAL_SALES_ERROR = 'GET_ANNUAL_SALES_ERROR';

export const GET_TRANSACTION_SUMMARY_BY_BUDTENDER = 'GET_TRANSACTION_SUMMARY_BY_BUDTENDER';
export const GOT_TRANSACTION_SUMMARY_BY_BUDTENDER = 'GOT_TRANSACTION_SUMMARY_BY_BUDTENDER';
export const GET_TRANSACTION_SUMMARY_BY_BUDTENDER_ERROR = 'GET_TRANSACTION_SUMMARY_BY_BUDTENDER_ERROR';

export const GET_PRODUCT_SALES = 'GET_PRODUCT_SALES';
export const GOT_PRODUCT_SALES = 'GOT_PRODUCT_SALES';
export const GET_PRODUCT_SALES_ERROR = 'GET_PRODUCT_SALES_ERROR';

export const GET_PRODUCT_RANKING = 'GET_PRODUCT_RANKING';
export const GOT_PRODUCT_RANKING = 'GOT_PRODUCT_RANKING';
export const GET_PRODUCT_RANKING_ERROR = 'GET_PRODUCT_RANKING_ERROR';

export const GET_CUSTOMER_SALES = 'GET_CUSTOMER_SALES';
export const GOT_CUSTOMER_SALES = 'GOT_CUSTOMER_SALES';
export const GET_CUSTOMER_SALES_ERROR = 'GET_CUSTOMER_SALES_ERROR';

export const GET_WAREHOUSE_TRANSFER_REPORT = 'GET_WAREHOUSE_TRANSFER_REPORT';
export const GOT_WAREHOUSE_TRANSFER_REPORT = 'GOT_WAREHOUSE_TRANSFER_REPORT';
export const GET_WAREHOUSE_TRANSFER_REPORT_ERROR = 'GET_WAREHOUSE_TRANSFER_REPORT_ERROR';

export const GET_DISCOUNT_REPORT = 'GET_DISCOUNT_REPORT';
export const GOT_DISCOUNT_REPORT = 'GOT_DISCOUNT_REPORT';
export const GET_DISCOUNT_REPORT_ERROR = 'GET_DISCOUNT_REPORT_ERROR';

export const GET_COMBINED_SALES_REPORT = 'GET_COMBINED_SALES_REPORT';
export const GOT_COMBINED_SALES_REPORT = 'GOT_COMBINED_SALES_REPORT';
export const GET_COMBINED_SALES_REPORT_ERROR = 'GET_COMBINED_SALES_REPORT_ERROR';

export const GET_AGGREGATE_BRANCHES_REPORT = 'GET_AGGREGATE_BRANCHES_REPORT';
export const GOT_AGGREGATE_BRANCHES_REPORT = 'GOT_AGGREGATE_BRANCHES_REPORT';
export const GET_AGGREGATE_BRANCHES_REPORT_ERROR = 'GET_AGGREGATE_BRANCHES_REPORT_ERROR';

export const GET_SHOPPING_TREND = 'GET_SHOPPING_TREND';
export const GOT_SHOPPING_TREND = 'GOT_SHOPPING_TREND';
export const GET_SHOPPING_TREND_ERROR = 'GET_SHOPPING_TREND_ERROR';

export const GET_PURCHASE_ORDER_REPORT = 'GET_PURCHASE_ORDER_REPORT';
export const GOT_PURCHASE_ORDER_REPORT = 'GOT_PURCHASE_ORDER_REPORT';
export const GET_PURCHASE_ORDER_REPORT_ERROR = 'GET_PURCHASE_ORDER_REPORT_ERROR';

export const GET_GENERAL_REPORT = 'GET_GENERAL_REPORT';
export const GOT_GENERAL_REPORT = 'GOT_GENERAL_REPORT';
export const GET_GENERAL_REPORT_ERROR = 'GET_GENERAL_REPORT_ERROR';

export const GET_HOURLY_SALES = 'GET_HOURLY_SALES';
export const GOT_HOURLY_SALES = 'GOT_HOURLY_SALES';
export const GET_HOURLY_SALES_ERROR = 'GET_HOURLY_SALES_ERROR';

export const GET_HOURLY_SALES_DATE_RANGE = 'GET_HOURLY_SALES_DATE_RANGE';
export const GOT_HOURLY_SALES_DATE_RANGE = 'GOT_HOURLY_SALES_DATE_RANGE';
export const GET_HOURLY_SALES_SECONDARY = 'GET_HOURLY_SALES_SECONDARY';
export const GOT_HOURLY_SALES_SECONDARY = 'GOT_HOURLY_SALES_SECONDARY';

export const GET_MANUAL_INVENTORY_CHANGE = 'GET_MANUAL_INVENTORY_CHANGE';
export const GOT_MANUAL_INVENTORY_CHANGE = 'GOT_MANUAL_INVENTORY_CHANGE';
export const GET_MANUAL_INVENTORY_CHANGE_ERROR = 'GET_MANUAL_INVENTORY_CHANGE_ERROR';

export const GET_INSTORE_ONLINE_SALES = 'GET_INSTORE_ONLINE_SALES';
export const GOT_INSTORE_ONLINE_SALES = 'GOT_INSTORE_ONLINE_SALES';
export const GET_INSTORE_ONLINE_SALES_ERROR = 'GET_INSTORE_ONLINE_SALES_ERROR';

export const GET_BRAND_SALES = 'GET_BRAND_SALES';
export const GOT_BRAND_SALES = 'GOT_BRAND_SALES';
export const GET_BRAND_SALES_ERROR = 'GET_BRAND_SALES_ERROR';

export const CLEAR_INVENTORY_CHART = 'CLEAR_INVENTORY_CHART';

export const GET_ORDER_LIST_SALES = 'GET_ORDER_LIST_SALES';
export const GOT_ORDER_LIST_SALES = 'GOT_ORDER_LIST_SALES';
export const GET_ORDER_LIST_SALES_ERROR = 'GET_ORDER_LIST_SALES_ERROR';

export const GET_PURCHASE_RECEIVER = 'GET_PURCHASE_RECEIVER';
export const GOT_PURCHASE_RECEIVER = 'GOT_PURCHASE_RECEIVER';

//Monthly Product Sales
export const GET_MONTHLY_PRODUCT_SALES = 'GET_MONTHLY_PRODUCT_SALES';
export const GOT_MONTHLY_PRODUCT_SALES = 'GOT_MONTHLY_PRODUCT_SALES';
export const GET_MONTHLY_PRODUCT_SALES_ERROR = 'GET_MONTHLY_PRODUCT_SALES_ERROR';

//Employee Timesheet
export const GET_EMPLOYEE_TIMESHEET = 'GET_EMPLOYEE_TIMESHEET';
export const GOT_EMPLOYEE_TIMESHEET = 'GOT_EMPLOYEE_TIMESHEET';
export const GET_EMPLOYEE_TIMESHEET_ERROR = 'GET_EMPLOYEE_TIMESHEET_ERROR';

//Employee Hours
export const GET_EMPLOYEE_HOURS = 'GET_EMPLOYEE_HOURS';
export const GOT_EMPLOYEE_HOURS = 'GOT_EMPLOYEE_HOURS';
export const GET_EMPLOYEE_HOURS_ERROR = 'GET_EMPLOYEE_HOURS_ERROR';

export const GET_DAILY_CASH_SUMMARY = 'GET_DAILY_CASH_SUMMARY';
export const GOT_DAILY_CASH_SUMMARY = 'GOT_DAILY_CASH_SUMMARY';
export const GET_DAILY_CASH_SUMMARY_ERROR = 'GET_DAILY_CASH_SUMMARY_ERROR';


export const GET_CREDIT_PAYMENTS = 'GET_CREDIT_PAYMENTS';
export const GOT_CREDIT_PAYMENTS = 'GOT_CREDIT_PAYMENTS';
export const GET_CREDIT_PAYMENTS_ERROR = 'GET_CREDIT_PAYMENTS_ERROR';

export const GET_GIFT_CARD_BALANCE = 'GET_GIFT_CARD_BALANCE';
export const GOT_GIFT_CARD_BALANCE = 'GOT_GIFT_CARD_BALANCE';
export const GET_GIFT_CARD_BALANCE_ERROR = 'GET_GIFT_CARD_BALANCE_ERROR';

export const GET_REORDER_REPORT = 'GET_REORDER_REPORT';
export const GOT_REORDER_REPORT = 'GOT_REORDER_REPORT';
export const GET_REORDER_REPORT_ERROR = 'GET_REORDER_REPORT_ERROR';

export const GET_END_OF_DAY_REPORT = 'GET_END_OF_DAY_REPORT';
export const GOT_END_OF_DAY_REPORT = 'GOT_END_OF_DAY_REPORT';
export const GET_END_OF_DAY_REPORT_ERROR = 'GET_END_OF_DAY_REPORT_ERROR';

export const GET_GMROI_REPORT = 'GET_GMROI_REPORT';
export const GOT_GMROI_REPORT = 'GOT_GMROI_REPORT';
export const GET_GMROI_REPORT_ERROR = 'GET_GMROI_REPORT_ERROR';

export const GET_SALES_DAILY_REPORT = 'GET_SALES_DAILY_REPORT';
export const GOT_SALES_DAILY_REPORT = 'GOT_SALES_DAILY_REPORT';
export const GET_SALES_DAILY_REPORT_ERROR = 'GET_SALES_DAILY_REPORT_ERROR';

export const GET_SALES_MONTHLY_REPORT = 'GET_SALES_MONTHLY_REPORT';
export const GOT_SALES_MONTHLY_REPORT = 'GOT_SALES_MONTHLY_REPORT';
export const GET_SALES_MONTHLY_REPORT_ERROR = 'GET_SALES_MONTHLY_REPORT_ERROR';

export const GET_PROFIT_DAILY_REPORT = 'GET_PROFIT_DAILY_REPORT';
export const GOT_PROFIT_DAILY_REPORT = 'GOT_PROFIT_DAILY_REPORT';
export const GET_PROFIT_DAILY_REPORT_ERROR = 'GET_PROFIT_DAILY_REPORT_ERROR';

export const GET_PROFIT_MONTHLY_REPORT = 'GET_PROFIT_MONTHLY_REPORT';
export const GOT_PROFIT_MONTHLY_REPORT = 'GOT_PROFIT_MONTHLY_REPORT';
export const GET_PROFIT_MONTHLY_REPORT_ERROR = 'GET_PROFIT_MONTHLY_REPORT_ERROR';

export const GET_SALES_YEARLY_REPORT = 'GET_SALES_YEARLY_REPORT';
export const GOT_SALES_YEARLY_REPORT = 'GOT_SALES_YEARLY_REPORT';
export const GET_SALES_YEARLY_REPORT_ERROR = 'GET_SALES_YEARLY_REPORT_ERROR';

export const GET_PROFIT_YEARLY_REPORT = 'GET_PROFIT_YEARLY_REPORT';
export const GOT_PROFIT_YEARLY_REPORT = 'GOT_PROFIT_YEARLY_REPORT';
export const GET_PROFIT_YEARLY_REPORT_ERROR = 'GET_PROFIT_YEARLY_REPORT_ERROR';

export const GET_SELL_THROUGH_REPORT = 'GET_SELL_THROUGH_REPORT';
export const GOT_SELL_THROUGH_REPORT = 'GOT_SELL_THROUGH_REPORT';
export const GET_SELL_THROUGH_REPORT_ERROR = 'GET_SELL_THROUGH_REPORT_ERROR';

export const GET_DEMOGRAPHIC_REPORT = 'GET_DEMOGRAPHIC_REPORT';
export const GOT_DEMOGRAPHIC_REPORT = 'GOT_DEMOGRAPHIC_REPORT';

export const GET_SALES_BY_TYPE = 'GET_SALES_BY_TYPE';
export const GOT_SALES_BY_TYPE = 'GOT_SALES_BY_TYPE';
export const GET_SALES_BY_TYPE_ERROR = 'GET_SALES_BY_TYPE_ERROR';

export const GET_DESTROYED_PRODUCT_REPORT = 'GET_DESTROYED_PRODUCT_REPORT';
export const GOT_DESTROYED_PRODUCT_REPORT = 'GOT_DESTROYED_PRODUCT_REPORT';
export const GET_DESTROYED_PRODUCT_REPORT_ERROR = 'GET_DESTROYED_PRODUCT_REPORT_ERROR';

export const GET_DISCREPANCY_REPORT = 'GET_DISCREPANCY_REPORT';
export const GOT_DISCREPANCY_REPORT = 'GOT_DISCREPANCY_REPORT';
export const GET_DISCREPANCY_REPORT_ERROR = 'GET_DISCREPANCY_REPORT_ERROR';


export const GET_TRANSACTION_SALES_SUMMARY = 'GET_TRANSACTION_SALES_SUMMARY';
export const GOT_TRANSACTION_SALES_SUMMARY = 'GOT_TRANSACTION_SALES_SUMMARY';
export const GET_TRANSACTION_SALES_SUMMARY_ERROR = 'GET_TRANSACTION_SALES_SUMMARY_ERROR';

export const GET_PROFIT_REPORT = 'GET_PROFIT_REPORT';
export const GOT_PROFIT_REPORT = 'GOT_PROFIT_REPORT';
export const GET_PROFIT_REPORT_ERROR = 'GET_PROFIT_REPORT_ERROR';

export const GET_REVENUE_REPORT = 'GET_REVENUE_REPORT';
export const GOT_REVENUE_REPORT = 'GOT_REVENUE_REPORT';
export const GET_REVENUE_REPORT_ERROR = 'GET_REVENUE_REPORT_ERROR';

export const GET_SALES_SUMMARY = 'GET_SALES_SUMMARY';
export const GOT_SALES_SUMMARY = 'GOT_SALES_SUMMARY';
export const GET_SALES_SUMMARY_ERROR = 'GET_SALES_SUMMARY_ERROR';

export const GET_TAX_SUMMARY = 'GET_TAX_SUMMARY';
export const GOT_TAX_SUMMARY = 'GOT_TAX_SUMMARY';
export const GET_TAX_SUMMARY_ERROR = 'GET_TAX_SUMMARY_ERROR';

export const GET_AGGREGATE_SALES = 'GET_AGGREGATE_SALES';
export const GOT_AGGREGATE_SALES = 'GOT_AGGREGATE_SALES';
export const GET_AGGREGATE_SALES_ERROR = 'GET_AGGREGATE_SALES_ERROR';

export const GET_AGGREGATE_INVENTORY = 'GET_AGGREGATE_INVENTORY';
export const GOT_AGGREGATE_INVENTORY = 'GOT_AGGREGATE_INVENTORY';
export const GET_AGGREGATE_INVENTORY_ERROR = 'GET_AGGREGATE_INVENTORY_ERROR';


export const GET_INVENTORY_LEVEL = 'GET_INVENTORY_LEVEL';
export const GOT_INVENTORY_LEVEL = 'GOT_INVENTORY_LEVEL';
export const GET_INVENTORY_LEVEL_ERROR = 'GET_INVENTORY_LEVEL_ERROR';

export const GET_INVENTORY_AGE = 'GET_INVENTORY_AGE';
export const GET_INVENTORY_AGE_SUCCESS = 'GET_INVENTORY_AGE_SUCCESS';
export const GET_INVENTORY_AGE_FAIL = 'GET_INVENTORY_AGE_FAIL';

export const GET_RESTOCK_BY_CAPS = 'GET_RESTOCK_BY_CAPS';
export const GET_RESTOCK_BY_CAPS_SUCCESS = 'GET_RESTOCK_BY_CAPS_SUCCESS';
export const GET_RESTOCK_BY_CAPS_FAIL = 'GET_RESTOCK_BY_CAPS_FAIL';

export const GET_PRICE_TRACKER = 'GET_PRICE_TRACKER';
export const GOT_PRICE_TRACKER = 'GOT_PRICE_TRACKER';
export const GET_PRICE_TRACKER_ERROR = 'GET_PRICE_TRACKER_ERROR';

export const GET_THCCBD_TRACKER = 'GET_THCCBD_TRACKER';
export const GOT_THCCBD_TRACKER = 'GOT_THCCBD_TRACKER';
export const GET_THCCBD_TRACKER_ERROR = 'GET_THCCBD_TRACKER_ERROR';

export const GET_SHIFT_BY_EMPLOYEE = 'GET_SHIFT_BY_EMPLOYEE';
export const GOT_SHIFT_BY_EMPLOYEE = 'GOT_SHIFT_BY_EMPLOYEE';
export const GET_SHIFT_BY_EMPLOYEE_ERROR = 'GET_SHIFT_BY_EMPLOYEE_ERROR';

export const GET_SHIFT_BY_DAY = 'GET_SHIFT_BY_DAY';
export const GOT_SHIFT_BY_DAY = 'GOT_SHIFT_BY_DAY';
export const GET_SHIFT_BY_DAY_ERROR = 'GET_SHIFT_BY_DAY_ERROR';

export const GET_INVENTORY_SNAP_SHOT = 'GET_INVENTORY_SNAP_SHOT';
export const GOT_INVENTORY_SNAP_SHOT = 'GOT_INVENTORY_SNAP_SHOT';
export const GET_INVENTORY_SNAP_SHOT_ERROR = 'GET_INVENTORY_SNAP_SHOT_ERROR';

export const GET_MONTHLY_INVENTORY = 'GET_MONTHLY_INVENTORY';
export const GOT_MONTHLY_INVENTORY = 'GOT_MONTHLY_INVENTORY';
export const GOT_MONTHLY_INVENTORY_ERROR = 'GOT_MONTHLY_INVENTORY_ERROR'

export const GET_INVENTORY_SNAP_SHOT_PRODUCT_VIEW = 'GET_INVENTORY_SNAP_SHOT_PRODUCT_VIEW';
export const GOT_INVENTORY_SNAP_SHOT_PRODUCT_VIEW = 'GOT_INVENTORY_SNAP_SHOT_PRODUCT_VIEW';
export const GET_INVENTORY_SNAP_SHOT_PRODUCT_VIEW_ERROR = 'GET_INVENTORY_SNAP_SHOT_PRODUCT_VIEW_ERROR';

export const DOWNLOAD_FEDERALREPORT = "DOWNLOAD_FEDERALREPORT";
export const DOWNLOAD_FEDERALREPORT_SUCCESS = "DOWNLOAD_FEDERALREPORT_SUCCESS";
export const DOWNLOAD_FEDERALREPORT_ERROR = "DOWNLOAD_FEDERALREPORT_ERROR";

export const GET_AGGREGATE_INVENTORY_LEVEL = 'GET_AGGREGATE_INVENTORY_LEVEL';
export const GET_AGGREGATE_INVENTORY_LEVEL_SUCCESS = 'GET_AGGREGATE_INVENTORY_LEVEL_SUCCESS';
export const GET_AGGREGATE_INVENTORY_LEVEL_FAIL = 'GET_AGGREGATE_INVENTORY_LEVEL_FAIL';

export const GET_CATEGORY_PRODUCTS = 'GET_CATEGORY_PRODUCTS';
export const GOT_CATEGORY_PRODUCTS = 'GOT_CATEGORY_PRODUCTS';
export const GET_CATEGORY_PRODUCTS_ERROR = 'GET_CATEGORY_PRODUCTS_ERROR';

export const GET_PRODUCT_PRICE_CHANGE_REPORT = 'GET_PRODUCT_PRICE_CHANGE_REPORT';
export const GOT_PRODUCT_PRICE_CHANGE_REPORT = 'GOT_PRODUCT_PRICE_CHANGE_REPORT';
export const GET_PRODUCT_PRICE_CHANGE_REPORT_ERROR = 'GET_PRODUCT_PRICE_CHANGE_REPORT_ERROR';

export const GET_DELIVERY_REPORT = 'GET_DELIVERY_REPORT';
export const GOT_DELIVERY_REPORT = 'GOT_DELIVERY_REPORT';
export const GET_DELIVERY_REPORT_ERROR = 'GET_DELIVERY_REPORT_ERROR';
export const GET_GIFT_CARD_REPORT = 'GET_GIFT_CARD_REPORT';
export const GOT_GIFT_CARD_REPORT = 'GOT_GIFT_CARD_REPORT';
export const GET_GIFT_CARD_REPORT_ERROR = 'GET_GIFT_CARD_REPORT_ERROR';
export const GET_INVENTORY_MOVEMENT_REPORT = 'GET_INVENTORY_MOVEMENT_REPORT';
export const GET_INVENTORY_MOVEMENT_REPORT_SUCCESS = 'GET_INVENTORY_MOVEMENT_REPORT_SUCCESS';
export const GET_INVENTORY_MOVEMENT_REPORT_ERROR = 'GET_INVENTORY_MOVEMENT_REPORT_ERROR';
export const GET_INVENTORY_LOG_REPORT = 'GET_INVENTORY_LOG_REPORT';
export const GET_INVENTORY_LOG_REPORT_SUCCESS = 'GET_INVENTORY_LOG_REPORT_SUCCESS';
export const GET_INVENTORY_LOG_REPORT_ERROR = 'GET_INVENTORY_LOG_REPORT_ERROR';

export const GET_SALES_SUMMARY_WITH_DETAILS = 'GET_SALES_SUMMARY_WITH_DETAILS';
export const GET_SALES_SUMMARY_WITH_DETAILS_SUCCESS = 'GET_SALES_SUMMARY_WITH_DETAILS_SUCCESS';
export const GET_SALES_SUMMARY_WITH_DETAILS_ERROR = 'GET_SALES_SUMMARY_WITH_DETAILS_ERROR';

export const GET_AGGREGATE_BRANCH_SALES_INVENTORY = 'GET_AGGREGATE_BRANCH_SALES_INVENTORY';
export const GET_AGGREGATE_BRANCH_SALES_INVENTORY_SUCCESS = 'GET_AGGREGATE_BRANCH_SALES_INVENTORY_SUCCESS';
export const GET_AGGREGATE_BRANCH_SALES_INVENTORY_ERROR = 'GET_AGGREGATE_BRANCH_SALES_INVENTORY_ERROR';

export const GET_AUDIT_REPORT = 'GET_AUDIT_REPORT';
export const GET_AUDIT_REPORT_SUCCESS = 'GET_AUDIT_REPORT_SUCCESS';
export const GET_AUDIT_REPORT_ERROR = 'GET_AUDIT_REPORT_ERROR';

export const GET_UNCOUNTED_REPORT = 'GET_UNCOUNTED_REPORT';
export const GET_UNCOUNTED_REPORT_SUCCESS = 'GET_UNCOUNTED_REPORT_SUCCESS';
export const GET_UNCOUNTED_REPORT_ERROR = 'GET_UNCOUNTED_REPORT_ERROR';
export const GET_SAGE_EXPORT_GUID = 'GET_SAGE_EXPORT_GUID';
export const GET_SAGE_EXPORT_GUID_SUCCESS = 'GET_SAGE_EXPORT_GUID_SUCCESS';
export const GET_INVENTORY_AT_DATE_GUID = 'GET_INVENTORY_AT_DATE_GUID';
export const GET_INVENTORY_AT_DATE_GUID_SUCCESS = 'GET_INVENTORY_AT_DATE_GUID_SUCCESS';

// MIX AND MATCH
export const CLEAN_MIX_AND_MATCH_FORM = 'CLEAN_MIX_AND_MATCH_FORM';
export const SAVE_MIX_AND_MATCH = 'SAVE_MIX_AND_MATCH';
export const SAVE_MIX_AND_MATCH_SUCCESS = 'SAVE_MIX_AND_MATCH_SUCCESS';
export const SAVE_MIX_AND_MATCH_ERROR = 'SAVE_MIX_AND_MATCH_ERROR';
export const GET_MIX_AND_MATCH_BY_ID = 'GET_MIX_AND_MATCH_BY_ID';
export const MIX_AND_MATCH_BY_ID_GOT = 'MIX_AND_MATCH_BY_ID_GOT';
export const MIX_AND_MATCH_BY_ID_ERROR = 'MIX_AND_MATCH_BY_ID_ERROR';
export const GET_MIX_AND_MATCHES = 'GET_MIX_AND_MATCHES';
export const MIX_AND_MATCHES_GOT = 'MIX_AND_MATCHES_GOT';
export const GET_MIX_AND_MATCHES_ERROR = 'GET_MIX_AND_MATCHES_ERROR';

//REWARD
export const SAVE_PATIENT_REWARD = 'SAVE_PATIENT_REWARD';
export const GOT_PATIENT_REWARD = 'GOT_PATIENT_REWARD';
export const UPDATE_PATIENT_REWARD = 'UPDATE_PATIENT_REWARD';
export const SET_PATIENT_REWARD_SUCCESS = 'SET_PATIENT_REWARD_SUCCESS';
export const SET_PATIENT_REWARD_ERROR = 'SET_PATIENT_REWARD_ERROR';
export const SET_PATIENT_REWARD_RESET = 'SET_PATIENT_REWARD_RESET';
export const REWARD_POINTS_GOT = 'REWARD_POINTS_GOT';
export const REWARD_POINTS_ERROR = 'REWARD_POINTS_ERROR';
export const GET_REWARD_POINTS = 'GET_REWARD_POINTS';
export const UPDATE_PATIENT_VISIT_COUNT = 'UPDATE_PATIENT_VISIT_COUNT';
export const SET_PATIENT_VISIT_SUCCESS = 'SET_PATIENT_VISIT_SUCCESS';
export const SET_PATIENT_VISIT_ERROR = 'SET_PATIENT_VISIT_ERROR';
export const SET_PATIENT_VISIT_RESET = 'SET_PATIENT_VISIT_RESET';

//Ecommerce Admin
export const GET_PRODUCT_GROUP_LIST = 'GET_PRODUCT_GROUP_LIST';
export const GOT_PRODUCT_GROUP_LIST = 'GOT_PRODUCT_GROUP_LIST';
//export const GET_PRODUCT_GROUP_BY_ID = 'GET_PRODUCT_GROUP_BY_ID';
export const GET_STORE_RULES = 'GET_STORE_RULES';
export const GET_STORE_RULES_SUCCESS = 'GET_STORE_RULES_SUCCESS';
export const DELETE_STORE_RULES = 'DELETE_STORE_RULES';
export const DELETE_STORE_RULES_SUCCESS = 'DELETE_STORE_RULES_SUCCESS';
export const SAVE_STORE_RULES = 'SAVE_STORE_RULES';
export const SAVE_STORE_RULES_SUCCESS = 'SAVE_STORE_RULES_SUCCESS';
export const UPDATE_STORE_RULES = 'UPDATE_STORE_RULES';
export const UPDATE_STORE_RULES_SUCCESS = 'UPDATE_STORE_RULES_SUCCESS';
export const GET_STORE_RULE_BY_ID = 'GET_STORE_RULE_BY_ID';
export const GET_STORE_RULE_BY_ID_SUCCESS = 'GET_STORE_RULE_BY_ID_SUCCESS';
export const SAVE_STORE_RULES_CONTENT = 'SAVE_STORE_RULES_CONTENT';
export const SAVE_STORE_RULES_CONTENT_SUCCESS = 'SAVE_STORE_RULES_CONTENT_SUCCESS';
export const PRODUCT_GROUP_LOAD_FORM = 'PRODUCT_GROUP_LOAD_FORM';
export const ERROR_PRODUCT_GROUP_BY_ID = 'ERROR_PRODUCT_GROUP_BY_ID';
export const PRODUCT_GROUP_SAVED = 'PRODUCT_GROUP_SAVED';
export const PRODUCT_GROUP_SAVE_ERROR = 'PRODUCT_GROUP_SAVE_ERROR';
export const INIT_PRODUCT_GROUP_FORM = 'INIT_PRODUCT_GROUP_FORM';
export const INIT_CAROUSEL_PRODUCT_GROUP_FORM = 'INIT_CAROUSEL_PRODUCT_GROUP_FORM';
export const INIT_STORE_RULES_FORM = 'INIT_STORE_RULES_FORM';
export const GET_PRODUCT_GROUP_BY_ID = 'GET_PRODUCT_GROUP_BY_ID';
export const GET_PRODUCT_GROUP_BY_ID_GOT = 'GET_PRODUCT_GROUP_BY_ID_GOT';
export const GET_PRODUCT_GROUP_BY_ID_ERROR = 'GET_PRODUCT_GROUP_BY_ID_ERROR';
export const SAVE_PRODUCT_GROUP = 'SAVE_PRODUCT_GROUP';
export const UPDATE_PRODUCT_GROUP = 'UPDATE_PRODUCT_GROUP';
export const UPDATE_PRODUCT_GROUP_SAVED = 'UPDATE_PRODUCT_GROUP_SAVED';
export const UPDATE_PRODUCT_GROUP_ERROR = 'UPDATE_PRODUCT_GROUP_ERROR';
export const UPDATE_PRODUCT_CAMPAIGNS = 'UPDATE_PRODUCT_CAMPAIGNS';
export const CLEAR_PRODUCT_GROUP_ITEMS_DIALOG = 'CLEAR_PRODUCT_GROUP_ITEMS_DIALOG';
export const SAVE_HOME_SETTINGS = 'SAVE_HOME_SETTINGS';
export const SAVE_HOME_SETTINGS_SUCCESS = 'SAVE_HOME_SETTINGS_SUCCESS';
export const SAVE_HOME_SETTINGS_ERROR = 'SAVE_HOME_SETTINGS_ERROR';
export const GET_HOME_SETTINGS = 'GET_HOME_SETTINGS';
export const GET_HOME_SETTINGS_SUCCESS = 'GET_HOME_SETTINGS_SUCCESS';
export const GET_HOME_SETTINGS_ERROR = 'GET_HOME_SETTINGS_ERROR';
export const UPDATE_HOME_SETTINGS = 'UPDATE_HOME_SETTINGS';
export const GET_PRODUCT_GROUP_HOME = 'GET_PRODUCT_GROUP_HOME';
export const HOME_SETTINGS_UPDATE_SUCCESS = 'HOME_SETTINGS_UPDATE_SUCCESS';
export const HOME_SETTINGS_UPDATE_FAIL = 'HOME_SETTINGS_UPDATE_FAIL';
export const GET_WEB_UI_SETTINGS = 'GET_WEB_UI_SETTINGS';
export const GET_DELIVERY_ZONE = 'GET_DELIVERY_ZONE';
export const GET_DELIVERY_ZONE_SUCCESS = 'GET_DELIVERY_ZONE_SUCCESS';
export const GET_DELIVERY_ZONE_FAIL = 'GET_DELIVERY_ZONE_FAIL';
export const CREATE_DELIVERY_ZONE = 'CREATE_DELIVERY_ZONE';
export const CREATE_DELIVERY_ZONE_SUCCESS = 'CREATE_DELIVERY_ZONE_SUCCESS';
export const CREATE_DELIVERY_ZONE_FAIL = 'CREATE_DELIVERY_ZONE_FAIL';
export const DELETE_DELIVERY_ZONE = 'DELETE_DELIVERY_ZONE';
export const DELETE_DELIVERY_ZONE_SUCCESS = 'DELETE_DELIVERY_ZONE_SUCCESS';
export const DELETE_DELIVERY_ZONE_FAIL = 'DELETE_DELIVERY_ZONE_FAIL';
export const UPDATE_DELIVERY_ZONE = 'UPDATE_DELIVERY_ZONE';
export const UPDATE_DELIVERY_ZONE_SUCCESS = 'UPDATE_DELIVERY_ZONE_SUCCESS';
export const UPDATE_DELIVERY_ZONE_FAIL = 'UPDATE_DELIVERY_ZONE_FAIL';
export const GET_WEB_UI_SETTINGS_SUCCESS = 'GET_WEB_UI_SETTINGS_SUCCESS';
export const GET_WEB_UI_SETTINGS_INTEGRATION_SUCCESS = 'GET_WEB_UI_SETTINGS_INTEGRATION_SUCCESS';
export const GET_WEB_UI_SETTINGS_FAIL = 'GET_WEB_UI_SETTINGS_FAIL';
export const SAVE_WEB_UI_SETTINGS = 'SAVE_WEB_UI_SETTINGS';
export const SAVE_WEB_UI_SETTINGS_SUCCESS = 'SAVE_WEB_UI_SETTINGS_SUCCESS';
export const SAVE_WEB_UI_SETTINGS_FAIL = 'SAVE_WEB_UI_SETTINGS_FAIL';
//PIN
export const AUTH_PIN_PASSWORD = 'AUTH_PIN_PASSWORD';
export const AUTH_PIN_PASSWORD_SUCCESS = 'AUTH_PIN_PASSWORD_SUCCESS';
export const AUTH_PIN_PASSWORD_FAIL = 'AUTH_PIN_PASSWORD_FAIL';
export const VALIDATE_PIN_PASSWORD = 'VALIDATE_PIN_PASSWORD';
export const VALIDATE_PIN_PASSWORD_SUCCESS = 'VALIDATE_PIN_PASSWORD_SUCCESS';
export const VALIDATE_PIN_PASSWORD_FAIL = 'VALIDATE_PIN_PASSWORD_FAIL';
export const RESET_VALIDATE_PIN_PASSWORD = 'RESET_VALIDATE_PIN_PASSWORD';
export const AUTH_PIN_LOCK = 'AUTH_PIN_LOCK';
export const NEW_PIN = 'NEW_PIN';
export const NEW_PIN_SUCCESS = 'NEW_PIN_SUCCESS';
export const SET_USER_PIN_TO_STORE = 'SET_USER_PIN_TO_STORE';
//CHECKIN
export const ADD_CHECK_IN = 'ADD_TO_CHECKIN';
export const ADD_CHECK_IN_SUCCESS = 'ADD_CHECK_IN_SUCCESS';
export const CHECK_IN_SEARCH = 'CHECK_IN_SEARCH';
export const CHECK_IN_SEARCH_SUCCESS = 'CHECK_IN_SEARCH_SUCCESS';
export const CLEAN_ADD_CHECKIN_STORE = 'CLEAN_ADD_CHECKIN_STORE';
export const ADD_CHECK_IN_FAIL = 'ADD_CHECK_IN_FAIL';
export const REMOVE_CHECK_IN = 'REMOVE_CHECK_IN';
export const REMOVE_CHECK_IN_SUCCESS = 'REMOVE_CHECK_IN_SUCCESS';
export const REMOVE_CHECK_IN_ERROR = 'REMOVE_CHECK_IN_ERROR';
export const GET_CHECK_IN = 'GET_CHECK_IN';
export const SEND_MERMBER_MERGE = 'SEND_MERMBER_MERGE';
export const GET_CHECK_IN_SUCCESS = 'GET_CHECK_IN_SUCCESS';
export const GET_CHECK_IN_FAIL = 'GET_CHECK_IN_FAIL';
export const GET_CHECK_IN_BY_ID = 'GET_CHECK_IN_BY_ID';
export const GET_CHECK_IN_BY_ID_SUCCESS = 'GET_CHECK_IN_BY_ID_SUCCESS';
export const GET_CHECK_IN_BY_ID_FAIL = 'GET_CHECK_IN_BY_ID_FAIL';
export const HANDLE_CHECKIN_DIALOG = 'HANDLE_CHECKIN_DIALOG';
//DASHBOARD
export const DASHBOARD_FAIL = 'GET_DASHBOARD_FAIL';
export const GET_ORDERS = 'GET_ORDERS';
export const DB_ORDERS_GOT = 'DB_ORDERS_GOT';
export const GET_CASHDRAWER = 'GET_CASHDRAWER';
export const DB_CASHDRAWER_GOT = 'DB_CASHDRAWER_GOT';
export const GET_SALES = 'GET_SALES';
export const DB_SALES_GOT = 'DB_SALES_GOT';
export const GET_TOP_PRODUCTS_SALES = 'TOP_PRODUCTS_SALES';
export const DB_TOP_PRODUCTS_SALES_GOT = 'DB_TOP_PRODUCTS_SALES_GOT';
export const GET_TOP_MEMBERS = 'GET_TOP_MEMBERS';
export const DB_TOP_MEMBERS_GOT = 'DB_TOP_MEMBERS_GOT';
export const GET_TOP_SELLERS = 'GET_TOP_SELLERS';
export const DB_TOP_SELLERS_GOT = 'DB_TOP_SELLERS_GOT';
export const GET_TIMESHEET = 'GET_TIMESHEET';
export const DB_TIMESHEET_GOT = 'DB_TIMESHEET_GOT';
export const GET_PURCHASE_ORDER = 'GET_PURCHASE_ORDER';
export const DB_PURCHASE_ORDER_GOT = 'DB_PURCHASE_ORDER_GOT';
export const GET_INVENTORY = 'GET_INVENTORY';
export const DB_INVENTORY_GOT = 'DB_INVENTORY_GOT';
export const GET_CAMPAIGN = 'GET_CAMPAIGN';
export const DB_CAMPAIGN_GOT = 'DB_CAMPAIGN_GOT';
export const REMOVE_CACHE = 'REMOVE_CACHE';
export const REMOVE_CACHE_SUCCESS = 'REMOVE_CACHE_SUCCESS';
export const REMOVE_CACHE_FAIL = 'REMOVE_CACHE_FAIL';

//SCHEDULES
export const GET_SCHEDULES = 'GET_SCHEDULES';
export const GOT_SCHEDULES = 'GOT_SCHEDULES';
export const GOT_SCHEDULES_ERROR = 'GOT_SCHEDULES_ERROR';
export const GET_SCHEDULE_BY_ID = 'GET_SCHEDULE_BY_ID';
export const GOT_SCHEDULE_BY_ID = 'GOT_SCHEDULE_BY_ID';
export const GOT_SCHEDULE_BY_ID_ERROR = 'GOT_SCHEDULE_BY_ERROR';
export const CREATE_SCHEDULE = 'CREATE_SCHEDULE';
export const CREATE_SCHEDULE_SUCCESS = 'CREATE_SCHEDULE_SUCCESS';
export const CREATE_SCHEDULE_ERROR = 'CREATE_SCHEDULE_ERROR';
export const CREATE_SCHEDULE_RECURSIVE = 'CREATE_SCHEDULE_RECURSIVE';
export const ADD_NEW_TIME_SLOT = 'ADD_NEW_TIME_SLOT';
export const ADD_NEW_TIME_SLOT_SUCCESS = 'ADD_NEW_TIME_SLOT_SUCCESS';
export const REMOVE_TIME_SLOT = 'REMOVE_TIME_SLOT';
export const REMOVE_TIME_SLOT_SUCCESS = 'REMOVE_TIME_SLOT_SUCCESS';
export const GET_CUSTOM_TIME_SLOTS = 'GET_CUSTOM_TIME_SLOTS';
export const GOT_CUSTOM_TIME_SLOTS = 'GOT_CUSTOM_TIME_SLOTS';
export const REMOVE_SCHEDULE = 'REMOVE_SCHEDULE';
export const REMOVE_SCHEDULE_RECURSIVE = 'REMOVE_SCHEDULE_RECURSIVE';
export const REMOVE_SCHEDULE_SUCCESS = 'REMOVE_SCHEDULE_SUCCESS';
export const GET_SCHEDULE_BY_EMPLOYEE = 'GET_SCHEDULE_BY_EMPLOYEE';
export const GOT_SCHEDULE_BY_EMPLOYEE = 'GOT_SCHEDULE_BY_EMPLOYEE';
export const GOT_SCHEDULE_BY_EMPLOYEE_ERROR = 'GOT_SCHEDULE_BY_EMPLOYEE_ERROR';
export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE';
export const UPDATE_SCHEDULE_SUCCESS = 'UPDATE_SCHEDULE_SUCCESS';
export const UPDATE_SCHEDULE_ERROR = 'UPDATE_SCHEDULE_ERROR';
export const SEND_SCHEDULE = 'SEND_SCHEDULE';
export const SEND_SCHEDULE_SUCCESS = 'SEND_SCHEDULE_SUCCESS';
export const CLEAR_SCHEDULES_AND_EMPLOYEES = 'CLEAR_SCHEDULES_AND_EMPLOYEES';
export const GET_ONLINE_ORDER = 'GET_ONLINE_ORDER';
export const GET_ONLINE_ORDER_SUCCESS = 'GET_ONLINE_ORDER_SUCCESS';
export const GET_CLEAR_UNPRINTED_ORDER_SUCCESS = 'GET_CLEAR_UNPRINTED_ORDER_SUCCESS';
export const CLEAR_UNPRINTED_ORDER = 'CLEAR_UNPRINTED_ORDER';
export const GET_ONLINE_ORDER_FAIL = 'GET_ONLINE_ORDER_FAIL';
export const GET_ONLINE_ORDER_DETAILS = 'GET_ONLINE_ORDER_DETAILS';
export const GET_ONLINE_ORDER_DETAILS_SUCCESS = 'GET_ONLINE_ORDER_DETAILS_SUCCESS';
export const GET_ONLINE_ORDER_DETAILS_FAIL = 'GET_ONLINE_ORDER_DETAILS_FAIL';
export const GET_ONLINE_ORDER_DETAILS_BY_CODE = 'GET_ONLINE_ORDER_DETAILS_BY_CODE';
export const GET_ONLINE_ORDER_DETAILS_BY_CODE_SUCCESS = 'GET_ONLINE_ORDER_DETAILS_BY_CODE_SUCCESS';
export const GET_ONLINE_ORDER_DETAILS_BY_CODE_FAIL = 'GET_ONLINE_ORDER_DETAILS_BY_CODE_FAIL';
export const UPDATE_STATUS_ONLINE_ORDER = 'UPDATE_STATUS_ONLINE_ORDER';
export const CANCEL_ONLINE_ORDER = 'CANCEL_ONLINE_ORDER';
export const CANCEL_ONLINE_ORDER_SUCCESS = 'CANCEL_ONLINE_ORDER_SUCCESS';
export const CANCEL_ONLINE_ORDER_FAIL = 'CANCEL_ONLINE_ORDER_FAIL';
export const UPDATE_STATUS_ONLINE_ORDER_SUCCESS = 'UPDATE_STATUS_ONLINE_ORDER_SUCCESS';
export const UPDATE_STATUS_ONLINE_ORDER_FAIL = 'UPDATE_STATUS_ONLINE_ORDER_FAIL';
export const GENERATE_ORDER_BASED_ONLINE_ORDER = 'GENERATE_ORDER_BASED_ONLINE_ORDER';
export const GENERATE_ORDER_BASED_ONLINE_ORDER_SUCCESS = 'GENERATE_ORDER_BASED_ONLINE_ORDER_SUCCESS';
export const GENERATE_ORDER_BASED_ONLINE_ORDER_FAIL = 'GENERATE_ORDER_BASED_ONLINE_ORDER_FAIL';
export const GET_ONLINE_ORDERS_QUEUE = 'GET_ONLINE_ORDERS_QUEUE';
export const GET_ONLINE_ORDERS_QUEUE_SUCCESS = 'GET_ONLINE_ORDERS_QUEUE_SUCCESS';
export const GET_ONLINE_ORDERS_QUEUE_FAIL = 'GET_ONLINE_ORDERS_QUEUE_FAIL';
export const GET_OPEN_ONLINE_ORDERS_COUNT = 'GET_OPEN_ONLINE_ORDERS_COUNT';
export const GET_OPEN_ONLINE_ORDERS_COUNT_SUCCESS = 'GET_OPEN_ONLINE_ORDERS_COUNT_SUCCESS';
export const GET_OPEN_ONLINE_ORDERS_COUNT_FAIL = 'GET_OPEN_ONLINE_ORDERS_COUNT_FAIL';
export const GET_WORDPRESS_ORDER_LIST_UPDATE = 'GET_WORDPRESS_ORDER_LIST_UPDATE';
export const GET_WORDPRESS_ORDER_LIST_UPDATE_SUCCESS = 'GET_WORDPRESS_ORDER_LIST_UPDATE_SUCCESS';
export const GET_WORDPRESS_ORDER_LIST_UPDATE_FAIL = 'GET_WORDPRESS_ORDER_LIST_UPDATE_FAIL';
export const GET_MANUAL_WORDPRESS_ORDER_LIST_UPDATE = 'GET_MANUAL_WORDPRESS_ORDER_LIST_UPDATE';
export const GET_MANUAL_WORDPRESS_ORDER_LIST_UPDATE_SUCCESS = 'GET_MANUAL_WORDPRESS_ORDER_LIST_UPDATE_SUCCESS';
export const GET_MANUAL_WORDPRESS_ORDER_LIST_UPDATE_FAIL = 'GET_MANUAL_WORDPRESS_ORDER_LIST_UPDATE_FAIL';
export const GET_PICKUP_ORDERS_QUEUE = 'GET_PICKUP_ORDERS_QUEUE';
export const GET_PICKUP_ORDERS_QUEUE_SUCCESS = 'GET_PICKUP_ORDERS_QUEUE_SUCCESS';
export const GET_PICKUP_ORDERS_QUEUE_FAIL = 'GET_PICKUP_ORDERS_QUEUE_FAIL';
export const GET_PICKUP_ORDER_DETAILS_BY_CODE = 'GET_PICKUP_ORDER_DETAILS_BY_CODE';
export const GET_PICKUP_ORDER_DETAILS_BY_CODE_SUCCESS = 'GET_PICKUP_ORDER_DETAILS_BY_CODE_SUCCESS';
export const GET_PICKUP_ORDER_DETAILS_BY_CODE_FAIL = 'GET_PICKUP_ORDER_DETAILS_BY_CODE_FAIL';
export const FINISH_PICKUP_ORDER = 'FINISH_PICKUP_ORDER';
export const FINISH_PICKUP_ORDER_SUCCESS = 'FINISH_PICKUP_ORDER_SUCCESS';
export const FINISH_PICKUP_ORDER_FAIL = 'FINISH_PICKUP_ORDER_FAIL';
export const UPDATE_PICKUP_PRODUCTS = 'UPDATE_PICKUP_PRODUCTS';
export const CREATE_PRESCRIPTION = 'CREATE_PRESCRIPTION';
export const CREATE_PRESCRIPTION_SUCCESS = 'CREATE_PRESCRIPTION_SUCCESS';
export const CREATE_PRESCRIPTION_FAIL = 'CREATE_PRESCRIPTION_FAIL';
export const GET_PRESCRIPTIONS_BY_PATIENT = 'GET_PRESCRIPTIONS_BY_PATIENT';
export const GET_PRESCRIPTIONS_BY_PATIENT_SUCCESS = 'GET_PRESCRIPTIONS_BY_PATIENT_SUCCESS';
export const GET_PRESCRIPTIONS_BY_PATIENT_FAIL = 'GET_PRESCRIPTIONS_BY_PATIENT_FAIL';
export const GET_STORETODOOR_PICKUP_TIME = 'GET_STORETODOOR_PICKUP_TIME';
export const GET_STORETODOOR_PICKUP_TIME_SUCCESS = 'GET_STORETODOOR_PICKUP_TIME_SUCCESS';
export const GET_STORETODOOR_PICKUP_TIME_FAIL = 'GET_STORETODOOR_PICKUP_TIME_FAIL';
export const GET_STORETODOOR_LOCATION_INFO = 'GET_STORETODOOR_LOCATION_INFO';
export const GET_STORETODOOR_LOCATION_INFO_SUCCESS = 'GET_STORETODOOR_LOCATION_INFO_SUCCESS';
export const GET_STORETODOOR_LOCATION_INFO_FAIL = 'GET_STORETODOOR_LOCATION_INFO_FAIL';
export const SYNC_PRODUCTS_TO_LEAFLY = 'SYNC_PRODUCTS_TO_LEAFLY';
export const SYNC_PRODUCTS_TO_LEAFLY_SUCCESS = 'SYNC_PRODUCTS_TO_LEAFLY_SUCCESS';
export const SYNC_PRODUCTS_TO_LEAFLY_FAIL = 'SYNC_PRODUCTS_TO_LEAFLY_FAIL';
export const SYNC_PRODUCTS_TO_WEEDMAPS = 'SYNC_PRODUCTS_TO_WEEDMAPS';
export const TRACK_DRAWER_OPEN = 'TRACK_DRAWER_OPEN';
export const GET_MONERIS_RECEIPT_BY_ORDERID = 'GET_MONERIS_RECEIPT_BY_ORDERID';
export const GET_MONERIS_RECEIPT_BY_ORDERID_SUCCESS = 'GET_MONERIS_RECEIPT_BY_ORDERID_SUCCESS';
export const GET_MONERIS_RECEIPT_BY_ORDERID_FAIL = 'GET_MONERIS_RECEIPT_BY_ORDERID_FAIL';
export const SIGN_UP_ONLINE_USER = 'SIGN_UP_ONLINE_USER';
export const SIGN_UP_ONLINE_USER_SUCCESS = 'SIGN_UP_ONLINE_USER_SUCCESS';
export const SIGN_UP_ONLINE_USER_FAIL = 'SIGN_UP_ONLINE_USER_FAIL';

//GIFT CARDS
export const GIFT_CARD_CREATE_RELOAD = 'GIFT_CARD_CREATE_RELOAD';
export const GIFT_CARD_CREATE_RELOAD_SUCCESS = 'GIFT_CARD_CREATE_RELOAD_SUCCESS';
export const GIFT_CARD_CREATE_RELOAD_FAIL = 'GIFT_CARD_CREATE_RELOAD_FAIL';
export const GIFT_CARD_BALANCE_PAGE_CHECK = 'GIFT_CARD_BALANCE_PAGE_CHECK';
export const GIFT_CARD_BALANCE_PAGE_CHECK_SUCCESS = 'GIFT_CARD_BALANCE_PAGE_CHECK_SUCCESS';
export const GIFT_CARD_BALANCE_PAGE_CHECK_FAIL = 'GIFT_CARD_BALANCE_PAGE_CHECK_FAIL';
export const GIFT_CARD_INITIALIZATION = 'GIFT_CARD_INITIALIZATION';
export const GIFT_CARD_INITIALIZATION_SUCCESS = 'GIFT_CARD_INITIALIZATION_SUCCESS';
export const GIFT_CARD_INITIALIZATION_FAIL = 'GIFT_CARD_INITIALIZATION_FAIL';
export const GIFT_CARD_DATA_INQUIRY = 'GIFT_CARD_DATA_INQUIRY';
export const GIFT_CARD_DATA_INQUIRY_SUCCESS = 'GIFT_CARD_DATA_INQUIRY_SUCCESS';
export const GIFT_CARD_DATA_INQUIRY_FAIL = 'GIFT_CARD_DATA_INQUIRY_FAIL';
export const GIFT_CARD_PURCHASE = 'GIFT_CARD_PURCHASE';
export const GIFT_CARD_PURCHASE_SUCCESS = 'GIFT_CARD_PURCHASE_SUCCESS';
export const GIFT_CARD_PURCHASE_FAIL = 'GIFT_CARD_PURCHASE_FAIL';
export const GIFT_CARD_ACTIVATION = 'GIFT_CARD_ACTIVATION';
export const GIFT_CARD_ACTIVATION_SUCCESS = 'GIFT_CARD_ACTIVATION_SUCCESS';
export const GIFT_CARD_ACTIVATION_FAIL = 'GIFT_CARD_ACTIVATION_FAIL';
export const GIFT_CARD_DEACTIVATION = 'GIFT_CARD_DEACTIVATION';
export const GIFT_CARD_DEACTIVATION_SUCCESS = 'GIFT_CARD_DEACTIVATION_SUCCESS';
export const GIFT_CARD_DEACTIVATION_FAIL = 'GIFT_CARD_DEACTIVATION_FAIL';
export const GIFT_CARD_REFUND = 'GIFT_CARD_REFUND';
export const GIFT_CARD_REFUND_SUCCESS = 'GIFT_CARD_REFUND_SUCCESS';
export const GIFT_CARD_REFUND_FAIL = 'GIFT_CARD_REFUND_FAIL';
export const IMPORT_PRODUCTS_FROM_CATALOG = 'IMPORT_PRODUCTS_FROM_CATALOG';
export const IMPORT_PRODUCTS_FROM_CATALOG_SUCCESS = 'IMPORT_PRODUCTS_FROM_CATALOG_SUCCESS';
export const IMPORT_PRODUCTS_FROM_CATALOG_FAIL = 'IMPORT_PRODUCTS_FROM_CATALOG_FAIL';
export const IMPORT_ACCESSORY_FROM_CATALOG = 'IMPORT_ACCESSORY_FROM_CATALOG';
export const IMPORT_ACCESSORY_FROM_CATALOG_SUCCESS = 'IMPORT_ACCESSORY_FROM_CATALOG_SUCCESS';
export const IMPORT_ACCESSORY_FROM_CATALOG_FAIL = 'IMPORT_ACCESSORY_FROM_CATALOG_FAIL';
export const UPDATE_BC_CLOSING_INVENTORY = 'UPDATE_BC_CLOSING_INVENTORY';
export const UPDATE_BC_CLOSING_INVENTORY_SUCCESS = 'UPDATE_BC_CLOSING_INVENTORY_SUCCESS';
export const UPDATE_BC_CLOSING_INVENTORY_FAIL = 'UPDATE_BC_CLOSING_INVENTORY_FAIL';
export const UPDATE_CLOSING_INVENTORY = 'UPDATE_CLOSING_INVENTORY';
export const UPDATE_CLOSING_INVENTORY_SUCCESS = 'UPDATE_CLOSING_INVENTORY_SUCCESS';
export const UPDATE_CLOSING_INVENTORY_FAIL = 'UPDATE_CLOSING_INVENTORY_FAIL';
export const GET_CLOSING_INVENTORY_PRODUCT = 'GET_CLOSING_INVENTORY_PRODUCT';
export const GET_CLOSING_INVENTORY_PRODUCT_SUCCESS = 'GET_CLOSING_INVENTORY_PRODUCT_SUCCESS';
export const GET_CLOSING_INVENTORY_PRODUCT_FAIL = 'GET_CLOSING_INVENTORY_PRODUCT_FAIL';
export const PAYSTONE_GIFTCARD_OPERATION = 'PAYSTONE_GIFTCARD_OPERATION';
export const PAYSTONE_GIFTCARD_OPERATION_SUCCESS = 'PAYSTONE_GIFTCARD_OPERATION_SUCCESS';
export const PAYSTONE_GIFTCARD_OPERATION_FAIL = 'PAYSTONE_GIFTCARD_OPERATION_FAIL';
export const PAYSTONE_GIFTCARD_PURCHASE = 'PAYSTONE_GIFTCARD_PURCHASE';
export const PAYSTONE_GIFTCARD_PURCHASE_SUCCESS = 'PAYSTONE_GIFTCARD_PURCHASE_SUCCESS';
export const PAYSTONE_GIFTCARD_PURCHASE_FAIL = 'PAYSTONE_GIFTCARD_PURCHASE_FAIL';
export const PAYSTONE_GIFTCARD_REFUND = 'PAYSTONE_GIFTCARD_REFUND';
export const PAYSTONE_GIFTCARD_REFUND_SUCCESS = 'PAYSTONE_GIFTCARD_REFUND_SUCCESS';
export const PAYSTONE_GIFTCARD_REFUND_FAIL = 'PAYSTONE_GIFTCARD_REFUND_FAIL';
export const BIRCHMOUNT_GIFTCARD_OPERATION = 'BIRCHMOUNT_GIFTCARD_OPERATION';
export const BIRCHMOUNT_GIFTCARD_OPERATION_SUCCESS = 'BIRCHMOUNT_GIFTCARD_OPERATION_SUCCESS';
export const BIRCHMOUNT_GIFTCARD_OPERATION_FAIL = 'BIRCHMOUNT_GIFTCARD_OPERATION_FAIL';
export const BIRCHMOUNT_GIFT_CARD_PURCHASE = 'BIRCHMOUNT_GIFT_CARD_PURCHASE';
export const BIRCHMOUNT_GIFT_CARD_PURCHASE_SUCCESS = 'BIRCHMOUNT_GIFT_CARD_PURCHASE_SUCCESS';
export const BIRCHMOUNT_GIFT_CARD_REFUND = 'BIRCHMOUNT_GIFT_CARD_REFUND';
export const BIRCHMOUNT_GIFT_CARD_REFUND_SUCCESS = 'BIRCHMOUNT_GIFT_CARD_REFUND_SUCCESS';
export const CHARGE_GIFT_CARD_TO_ORDER = "CHARGE_GIFT_CARD_TO_ORDER"
export const CHARGE_GIFT_CARD_TO_ORDER_SUCCESS = "CHARGE_GIFT_CARD_TO_ORDER_SUCCESS"
export const CHARGE_GIFT_CARD_TO_ORDER_FAIL = "CHARGE_GIFT_CARD_TO_ORDER_FAIL"
export const CLEAR_PRODUCT_LIST = 'CLEAR_PRODUCT_LIST';
export const CLEAR_PO_LIST = 'CLEAR_PO_LIST';
export const CLEAR_PRODUCT_TYPE_LIST = 'CLEAR_PRODUCT_TYPE_LIST';
export const CLEAR_CATEGORY_TREE = 'CLEAR_CATEGORY_TREE';
export const CLEAR_PRODUCT_WAREHOUSES_LIST = 'CLEAR_PRODUCT_WAREHOUSES_LIST';
export const CLEAR_BULK_TRANSFER_LIST = 'CLEAR_BULK_TRANSFER_LIST';
export const CLEAR_BRAND_LIST = 'CLEAR_BRAND_LIST';
export const CLEAR_AUDIT_LIST = 'CLEAR_AUDIT_LIST';
export const CLEAR_PRICE_MATRIX = 'CLEAR_PRICE_MATRIX';
export const CLEAR_EMPLOYEE_LIST = 'CLEAR_EMPLOYEE_LIST';
export const CLEAR_EMPLOYEE_SHIFT = 'CLEAR_EMPLOYEE_SHIFT';
export const CLEAR_MEMBER_ORDER_LIST = 'CLEAR_MEMBER_ORDER_LIST';
export const CLEAR_MEMBER_LIST = 'CLEAR_MEMBER_LIST';
export const CLEAR_INVENTORY_AUDIT = 'CLEAR_INVENTORY_AUDIT';

//MOOD
export const ADD_MOOD = 'ADD_MOOD';
export const ADD_MOOD_SUCCESS = 'ADD_MOOD_SUCCESS';
export const RESET_ADD_MOOD = 'RESET_ADD_MOOD';
export const ASSIGN_MOOD = 'ASSIGN_MOOD';
export const ASSIGN_MOOD_SUCCESS = 'ASSIGN_MOOD_SUCCESS';
export const RESET_ASSIGN_MOODS = 'RESET_ASSIGN_MOODS';
export const GET_PRODUCT_MOODS = 'GET_PRODUCT_MOODS';
export const GET_PRODUCT_MOODS_SUCCESS = 'GET_PRODUCT_MOODS_SUCCESS';
export const GET_MOODS = 'GET_MOODS';
export const GET_MOODS_SUCCESS = 'GET_MOODS_SUCCESS';
export const DELETE_MOOD = 'DELETE_MOOD';

//TERPENE
export const ADD_TERPENE = 'ADD_TERPENE';
export const ADD_TERPENE_SUCCESS = 'ADD_TERPENE_SUCCESS';
export const RESET_ADD_TERPENE = 'RESET_ADD_TERPENE';
export const ASSIGN_TERPENE = 'ASSIGN_TERPENE';
export const ASSIGN_TERPENE_SUCCESS = 'ASSIGN_TERPENE_SUCCESS';
export const RESET_ASSIGN_TERPENES = 'RESET_ASSIGN_TERPENES';
export const GET_PRODUCT_TERPENES = 'GET_PRODUCT_TERPENES';
export const GET_PRODUCT_TERPENES_SUCCESS = 'GET_PRODUCT_TERPENES_SUCCESS';
export const GET_TERPENES = 'GET_TERPENES';
export const GET_TERPENES_SUCCESS = 'GET_TERPENES_SUCCESS';
export const DELETE_TERPENE = 'DELETE_TERPENE';
export const RESET_GET_TERPENES = 'RESET_GET_TERPENES';
export const SAVE_TERPENE = 'SAVE_TERPENE';

//MINOR CANABINOIDS
export const ADD_MINORCANABINOID = 'ADD_MINORCANABINOID';
export const ADD_MINORCANABINOID_SUCCESS = 'ADD_MINORCANABINOID_SUCCESS';
export const RESET_ADD_MINORCANABINOID = 'RESET_ADD_MINORCANABINOID';
export const ASSIGN_MINORCANABINOID = 'ASSIGN_MINORCANABINOID';
export const ASSIGN_MINORCANABINOID_SUCCESS = 'ASSIGN_MINORCANABINOID_SUCCESS';
export const RESET_ASSIGN_MINORCANABINOIDS = 'RESET_ASSIGN_MINORCANABINOIDS';
export const GET_PRODUCT_MINORCANABINOIDS = 'GET_PRODUCT_MINORCANABINOIDS';
export const GET_PRODUCT_MINORCANABINOIDS_SUCCESS = 'GET_PRODUCT_MINORCANABINOIDS_SUCCESS';
export const GET_MINORCANABINOIDS = 'GET_MINORCANABINOIDS';
export const GET_MINORCANABINOIDS_SUCCESS = 'GET_MINORCANABINOIDS_SUCCESS';
export const DELETE_MINORCANABINOID = 'DELETE_MINORCANABINOID';
export const RESET_GET_MINORCANABINOIDS = 'RESET_GET_MINORCANABINOIDS';
export const SAVE_MINORCANABINOID = 'SAVE_MINORCANABINOID';
export const SYNC_FROM_CATALOG = 'SYNC_FROM_CATALOG';
export const SYNC_FROM_CATALOG_SUCCESS = 'SYNC_FROM_CATALOG_SUCCESS';
export const SYNC_FROM_CATALOG_FAILED = 'SYNC_FROM_CATALOG_FAILED';

// MULTI STORE INVENTORY
export const GET_PRODUCT_INVENTORY_BY_BRANCH_DATE = "GET_PRODUCT_INVENTORY_BY_BRANCH_DATE";
export const GOT_PRODUCT_INVENTORY_BY_BRANCH_DATE = "GOT_PRODUCT_INVENTORY_BY_BRANCH_DATE";
export const GOT_PRODUCT_INVENTORY_BY_BRANCH_DATE_FAIL = "GOT_PRODUCT_INVENTORY_BY_BRANCH_DATE_FAIL";
export const GET_MULTI_BRANCH_INVENTORY = "GET_MULTI_BRANCH_INVENTORY";
export const GOT_MULTI_BRANCH_INVENTORY = "GOT_MULTI_BRANCH_INVENTORY";
export const GOT_MULTI_BRANCH_INVENTORY_FAIL = "GOT_MULTI_BRANCH_INVENTORY";
export const SET_RESTOCK_QTY = "SET_RESTOCK_QTY";
export const SET_RESTOCK_QTY_SUCCESS = "SET_RESTOCK_QTY_SUCCESS";
export const SET_RESTOCK_QTY_FAIL = "SET_RESTOCK_QTY_FAIL";
export const GET_SINGLE_PRODUCT_INVENTORY = "GET_SINGLE_PRODUCT_INVENTORY";
export const GOT_SINGLE_PRODUCT_INVENTORY = "GOT_SINGLE_PRODUCT_INVENTORY";
export const GOT_SINGLE_PRODUCT_INVENTORY_FAIL = "GOT_SINGLE_PRODUCT_INVENTORY_FAIL";

// REPORT AUTOMATION
export const SEND_REPORT_AUTOMATION = "SEND_REPORT_AUTOMATION";
export const SEND_REPORT_AUTOMATION_SUCCESS = "SEND_REPORT_AUTOMATION_SUCCESS";
export const SEND_REPORT_AUTOMATION_FAILED = "SEND_REPORT_AUTOMATION_FAILED";
export const GET_REPORT_AUTOMATION_INFO = "GET_REPORT_AUTOMATION_INFO";
export const GET_REPORT_AUTOMATION_INFO_SUCCESS = "GET_REPORT_AUTOMATION_INFO_SUCCESS";
export const GET_REPORT_AUTOMATION_INFO_FAILED = "GET_REPORT_AUTOMATION_INFO_FAILED";
export const UPDATE_REPORT_AUTOMATION_INFO = "UPDATE_REPORT_AUTOMATION_INFO";
export const UPDATE_REPORT_AUTOMATION_INFO_SUCCESS = "UPDATE_REPORT_AUTOMATION_INFO_SUCCESS";
export const UPDATE_REPORT_AUTOMATION_INFO_FAILED = "UPDATE_REPORT_AUTOMATION_INFO_FAILED";
export const DELETE_REPORT_AUTOMATION = "DELETE_REPORT_AUTOMATION";
export const DELETE_REPORT_AUTOMATION_SUCCESS = "DELETE_REPORT_AUTOMATION_SUCCESS";
export const DELETE_REPORT_AUTOMATION_FAILED = "DELETE_REPORT_AUTOMATION_FAILED";

//Store Lock Date And Time
export const GET_STORE_LOCK_DATE_AND_TIME = "GET_STORE_LOCK_DATE_AND_TIME";
export const GET_STORE_LOCK_DATE_AND_TIME_SUCCESS = "GET_STORE_LOCK_DATE_AND_TIME_SUCCESS";
export const GET_STORE_LOCK_DATE_AND_TIME_FAILED = "GET_STORE_LOCK_DATE_AND_TIME_FAILED";
export const CREATE_STORE_LOCK_DATE_AND_TIME = "CREATE_STORE_LOCK_DATE_AND_TIME";
export const CREATE_STORE_LOCK_DATE_AND_TIME_SUCCESS = "CREATE_STORE_LOCK_DATE_AND_TIME_SUCCESS";
export const CREATE_STORE_LOCK_DATE_AND_TIME_FAILED = "CREATE_STORE_LOCK_DATE_AND_TIME_FAILED";
export const DELETE_STORE_LOCK_DATE_AND_TIME = "DELETE_STORE_LOCK_DATE_AND_TIME";
export const DELETE_STORE_LOCK_DATE_AND_TIME_SUCCESS = "DELETE_STORE_LOCK_DATE_AND_TIME_SUCCESS";
export const DELETE_STORE_LOCK_DATE_AND_TIME_FAILED = "DELETE_STORE_LOCK_DATE_AND_TIME_FAILED";
export const UPDATE_STORE_LOCK_DATE_AND_TIME = "UPDATE_STORE_LOCK_DATE_AND_TIME";
export const UPDATE_STORE_LOCK_DATE_AND_TIME_SUCCESS = "UPDATE_STORE_LOCK_DATE_AND_TIME_SUCCESS";
export const UPDATE_STORE_LOCK_DATE_AND_TIME_FAILED = "UPDATE_STORE_LOCK_DATE_AND_TIME_FAILED";

//Bulk Price Update
export const BULK_PRICE_UPDATE_BY_EXCEL = "BULK_PRICE_UPDATE_BY_EXCEL";
export const UPLOAD_EXCEL_SUCCESS = 'UPLOAD_EXCEL_SUCCESS';
export const GET_BULK_PRICE_UPDATE_SCHEDULAR = "GET_BULK_PRICE_UPDATE_SCHEDULAR";
export const GET_BULK_PRICE_SCHEDULAR_SUCCESS = 'GET_BULK_PRICE_SCHEDULAR_SUCCESS';
export const DELETE_BULK_PRICE_LIST = "DELETE_BULK_PRICE_LIST";
export const DELETE_BULK_PRICE_LIST_SUCCESS = "DELETE_BULK_PRICE_LIST_SUCCESS";
export const UPDATE_BULK_PRICE_LIST = "UPDATE_BULK_PRICE_LIST";
export const UPDATE_BULK_PRICE_LIST_SUCCESS = "UPDATE_BULK_PRICE_LIST_SUCCESS";
export const VALIDATE_BULK_PRICE_EXCEL = "VALIDATE_BULK_PRICE_EXCEL";
export const VALIDATE_BULK_PRICE_EXCEL_SUCCESS = "VALIDATE_BULK_PRICE_EXCEL_SUCCESS";

// REPORT
export const GET_CSV_REPORT = "GET_CSV_REPOPT"
export const REPORT_LOADING_COMPLETE = "REPORT_LOADING_COMPLETE"
export const GET_ROLE_CLAIMS_SUCCESS = "GET_ROLE_CLAIMS_SUCCESS"
export const GET_ROLE_CLAIMS_FAILED = "GET_ROLE_CLAIMS_FAILED"
export const DOWNLOAD_ERROR = "DOWNLOAD_ERROR";
export const DOWNLOAD_SALESSUMMARY_SUCCESS = "DOWNLOAD_SALESSUMMARY_SUCCESS";
export const DOWNLOAD_SALESSUMMARY = "DOWNLOAD_SALESSUMMARY"

export const POST_NEW_PRODUCT_IMAGE = "POST_NEW_PRODUCT_IMAGE";
export const POST_NEW_PRODUCT_IMAGE_FAILED = "POST_NEW_PRODUCT_IMAGE_FAILED";
export const POST_NEW_PRODUCT_IMAGE_SUCCESS = "POST_NEW_PRODUCT_IMAGE_SUCCESS";


export const DELETE_PRODUCT_IMAGE_REQUEST = "DELETE_PRODUCT_IMAGE_REQUEST";
export const DELETE_PRODUCT_IMAGE_FAILED = "DELETE_PRODUCT_IMAGE_FAILED";
export const DELETE_PRODUCT_IMAGE_SUCCESS = "DELETE_PRODUCT_IMAGE_SUCCESS";
// STORE SEO SETTINGS
export const GET_STORE_SEO_SETTINGS_REQUEST = "GET_STORE_SEO_SETTINGS_REQUEST"
export const GET_STORE_SEO_SETTINGS_FAILED = "GET_STORE_SEO_SETTINGS_FAILED"
export const GET_STORE_SEO_SETTINGS_SUCCESS = "GET_STORE_SEO_SETTINGS_SUCCESS"
export const UPDATE_STORE_SEO_SETTINGS_REQUEST = "UPDATE_STORE_SEO_SETTINGS_REQUEST"
export const UPDATE_STORE_SEO_SETTINGS_FAILED = "UPDATE_STORE_SEO_SETTINGS_FAILED"
export const UPDATE_STORE_SEO_SETTINGS_SUCCESS = "UPDATE_STORE_SEO_SETTINGS_SUCCESS"
// Store To Door
export const CREATE_STORE_TO_DOOR_DELIVERY_TIME = "CREATE_STORE_TO_DOOR_DELIVERY_TIME";
export const CREATE_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS = "CREATE_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS";
export const CREATE_STORE_TO_DOOR_DELIVERY_TIME_FAILED = "CREATE_STORE_TO_DOOR_DELIVERY_TIME_FAILED";
export const GET_ALL_STORE_TO_DOOR_DELIVERY_TIME = "GET_ALL_STORE_TO_DOOR_DELIVERY_TIME";
export const GET_ALL_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS = "GET_ALL_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS";
export const GET_ALL_STORE_TO_DOOR_DELIVERY_TIME_FAILED = "GET_ALL_STORE_TO_DOOR_DELIVERY_TIME_FAILED";
export const DELETE_STORE_TO_DOOR_DELIVERY_TIME = "DELETE_STORE_TO_DOOR_DELIVERY_TIME";
export const DELETE_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS = "DELETE_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS";
export const DELETE_STORE_TO_DOOR_DELIVERY_TIME_FAILED = "DELETE_STORE_TO_DOOR_DELIVERY_TIME_FAILED";
export const UPDATE_STORE_TO_DOOR_DELIVERY_TIME = "UPDATE_STORE_TO_DOOR_DELIVERY_TIME";
export const UPDATE_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS = "UPDATE_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS";
export const UPDATE_STORE_TO_DOOR_DELIVERY_TIME_FAILED = "UPDATE_STORE_TO_DOOR_DELIVERY_TIME_FAILED";
export const RESET_UPDATE_STORE_TO_DOOR_DELIVERY_TIME = "RESET_UPDATE_STORE_TO_DOOR_DELIVERY_TIME";

// Product Info
export const GET_PRODUCT_INFO_REQUEST = "GET_PRODUCT_INFO_REQUEST";
export const GET_PRODUCT_INFO_FAILED = "GET_PRODUCT_INFO_FAILED";
export const GET_PRODUCT_INFO_SUCCESS = "GET_PRODUCT_INFO_SUCCESS";


// Product Group Image
export const GET_PRODUCT_GROUP_IMAGE_REQUEST = "GET_PRODUCT_GROUP_IMAGE_REQUEST";
export const GET_PRODUCT_GROUP_IMAGE_FAILED = "GET_PRODUCT_GROUP_IMAGE_FAILED";
export const GET_PRODUCT_GROUP_IMAGE_SUCCESS = "GET_PRODUCT_GROUP_IMAGE_SUCCESS";

export const ADD_PRODUCT_GROUP_IMAGE_REQUEST = "ADD_PRODUCT_GROUP_IMAGE_REQUEST";
export const ADD_PRODUCT_GROUP_IMAGE_FAILED = "ADD_PRODUCT_GROUP_IMAGE_FAILED";
export const ADD_PRODUCT_GROUP_IMAGE_SUCCESS = "ADD_PRODUCT_GROUP_IMAGE_SUCCESS";

export const DELETE_PRODUCT_GROUP_IMAGE_REQUEST = "DELETE_PRODUCT_GROUP_IMAGE_REQUEST";
export const DELETE_PRODUCT_GROUP_IMAGE_FAILED = "DELETE_PRODUCT_GROUP_IMAGE_FAILED";
export const DELETE_PRODUCT_GROUP_IMAGE_SUCCESS = "DELETE_PRODUCT_GROUP_IMAGE_SUCCESS";

export const ADYEN_PAYMENT_REQUEST = "ADYEN_PAYMENT_REQUEST";
export const ADYEN_PAYMENT_SUCCESS = "ADYEN_PAYMENT_SUCCESS";
export const ADYEN_PAYMENT_FAILED = "ADYEN_PAYMENT_FAILED";

export const ADYEN_REFUND_REQUEST = "ADYEN_REFUND_REQUEST";
export const ADYEN_REFUND_SUCCESS = "ADYEN_REFUND_SUCCESS";
export const ADYEN_REFUND_FAILED = "ADYEN_REFUND_FAILED";
///Banner
export const GET_ALL_BANNER_REQUEST = "GET_ALL_BANNER_REQUEST";
export const GET_ALL_BANNER_FAILED = "GET_ALL_BANNER_FAILED";
export const GET_ALL_BANNER_SUCCESS = "GET_ALL_BANNER_SUCCESS";

export const ADD_BANNER_REQUEST = "ADD_BANNER_REQUEST";
export const ADD_BANNER_FAILED = "ADD_BANNER_FAILED";
export const ADD_BANNER_SUCCESS = "ADD_BANNER_SUCCESS";

export const GET_BANNER_BY_ID_REQUEST = 'GET_BANNER_BY_ID_REQUEST';
export const GET_BANNER_BY_ID_SUCCESS = 'GET_BANNER_BY_ID_SUCCESS';
export const GET_BANNER_BY_ID_FAILED = 'GET_BANNER_BY_ID_FAILED';

export const UPDATE_BANNER_REQUEST = 'UPDATE_BANNER_REQUEST';
export const UPDATE_BANNER_SUCCESS = 'UPDATE_BANNER_SUCCESS';
export const UPDATE_BANNER_FAILED = 'UPDATE_BANNER_FAILED';

export const REMOVE_BANNER_IMAGE_REQUEST = 'REMOVE_BANNER_IMAGE_REQUEST';
export const REMOVE_BANNER_IMAGE_SUCCESS = 'REMOVE_BANNER_IMAGE_SUCCESS';
export const REMOVE_BANNER_IMAGE_FAILED = 'REMOVE_BANNER_IMAGE_FAILED';

export const INITIALIZE_BANNER_FORM = 'INITIALIZE_BANNER_FORM';
export const INITIALIZE_BANNER_FORM_SUCCESS = 'INITIALIZE_BANNER_FORM_SUCCESS';

export const REMOVE_BANNER_BY_ID_REQUEST = 'REMOVE_BANNER_BY_ID_REQUEST';
export const REMOVE_BANNER_SUCCESS = 'REMOVE_BANNER_SUCCESS';
export const REMOVE_BANNER_FAILED = 'REMOVE_BANNER_FAILED';
